webpackJsonp([9],{

/***/ "+2Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+GID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__("5fo9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567a9450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__("xp4f");
function injectStyle (ssrContext) {
  __webpack_require__("vIES")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567a9450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+VxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("18Zw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0365d158_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("9TgA");
function injectStyle (ssrContext) {
  __webpack_require__("4JrB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0365d158_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+WI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[(_vm.values.length === 0)?_c('div',{staticClass:"progress-bar",class:("progress-bar-" + _vm.type),style:(("width: " + _vm.value + "%;")),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"sr-only"},[_vm._t("default")],2)]):_vm._l((_vm.values),function(progress){return _c('div',{staticClass:"progress-bar",class:("progress-bar-" + (progress.type)),style:(("width: " + (progress.value) + "%;"))},[_c('span',{staticClass:"sr-only"})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+lQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+m/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['requiredText', 'email', 'number', 'url', 'idSource', 'idDestination'])),
  data: function data() {
    return {
      model: {
        requiredText: '',
        email: '',
        number: '',
        url: '',
        idSource: '',
        idDestination: ''
      },
      modelValidations: {
        requiredText: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        number: {
          required: true,
          decimal: true
        },
        url: {
          required: true,
          url: true
        },
        idSource: {
          required: true
        },
        idDestination: {
          required: true,
          confirmed: 'idSource'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "+mNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Paper Dashboard Headings")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Created using "),_c('a',{attrs:{"href":"https://www.google.com/fonts/specimen/Muli"}},[_vm._v("Muli")]),_vm._v(" Font Family\n          ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"typo-line"},[_c('h1',[_c('p',{staticClass:"category"},[_vm._v("Header 1")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Header 2")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h3',[_c('p',{staticClass:"category"},[_vm._v("Header 3")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h4',[_c('p',{staticClass:"category"},[_vm._v("Header 4")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h5',[_c('p',{staticClass:"category"},[_vm._v("Header 5")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h6',[_c('p',{staticClass:"category"},[_vm._v("Header 6")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',[_c('span',{staticClass:"category"},[_vm._v("Paragraph")]),_vm._v("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Quote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("\n                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n              ")]),_vm._v(" "),_c('small',[_vm._v("\n                Steve Jobs, CEO Apple\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Muted Text")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Coloured Text")]),_vm._v(" "),_c('p',{staticClass:"text-primary"},[_vm._v("\n              Text Primary - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-info"},[_vm._v("\n              Text Info - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_vm._v("\n              Text Success - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-warning"},[_vm._v("\n              Text Warning - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-danger"},[_vm._v("\n              Text Danger - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Small Tag")]),_vm._v("Header with small subtitle "),_c('br'),_vm._v(" "),_c('small',[_vm._v("\".small\" is a tag for the headers")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Lists")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Unordered List")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',{staticClass:"list-unstyled"},[_c('ul',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Ordered List")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Unstyled List")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Inline List")]),_vm._v(" "),_c('ul',{staticClass:"list-inline"},[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Blockquotes")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Default Blockquote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Blockquote with Citation")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]),_vm._v(" "),_c('small',[_vm._v("Someone famous in\n                    "),_c('cite',{attrs:{"title":"Source Title"}},[_vm._v("Source Title")])])])])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Code")]),_vm._v(" "),_c('p',[_vm._v("This is "),_c('code',[_vm._v(".css-class-as-code")]),_vm._v(", an example of an inline code element. Wrap inline code within a "),_c('code',[_vm._v("\n              <code>...</code>")]),_vm._v("tag.")]),_vm._v(" "),_c('pre',[_vm._v("1. #This is an example of preformatted text. 2. #Here is another line of code")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+sal":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/YGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValidationForms_RegisterForm_vue__ = __webpack_require__("37ho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidationForms_LoginForm_vue__ = __webpack_require__("Pfw2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidationForms_TypeValidationForm_vue__ = __webpack_require__("DfKf");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RegisterForm: __WEBPACK_IMPORTED_MODULE_0__ValidationForms_RegisterForm_vue__["a" /* default */],
    LoginForm: __WEBPACK_IMPORTED_MODULE_1__ValidationForms_LoginForm_vue__["a" /* default */],
    TypeValidationForm: __WEBPACK_IMPORTED_MODULE_2__ValidationForms_TypeValidationForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      registerModel: {},
      loginModel: {},
      typeValidationModel: {}
    };
  },

  methods: {
    onRegisterSubmit: function onRegisterSubmit(model, isValid) {
      this.registerModel = model;
    },
    onLoginSubmit: function onLoginSubmit(model, isValid) {
      this.loginModel = model;
    },
    onTypeValidationSubmit: function onTypeValidationSubmit(model, isValid) {
      this.typeValidationModel = model;
    }
  }
});

/***/ }),

/***/ "/ZBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showSwal: function showSwal(type) {
      if (type === 'basic') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Here\'s a message!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill'
        });
      } else if (type === 'title-and-text') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Here\'s a message!',
          text: 'It\'s pretty, isn\'t it?',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-info btn-fill'
        });
      } else if (type === 'success-message') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Good job!',
          text: 'You clicked the button!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        });
      } else if (type === 'warning-message-and-confirmation') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, delete it!',
          buttonsStyling: false
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        });
      } else if (type === 'warning-message-and-cancel') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Are you sure?',
          text: 'You will not be able to recover this imaginary file!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: 'Deleted!',
            text: 'Your imaginary file has been deleted.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            });
          }
        });
      } else if (type === 'custom-html') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'HTML example',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          html: 'You can use <b>bold text</b>, ' + '<a href="http://github.com">links</a> ' + 'and other HTML tags'
        });
      } else if (type === 'auto-close') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Auto close alert!',
          text: 'I will close in 2 seconds.',
          timer: 2000,
          showConfirmButton: false
        });
      } else if (type === 'input-field') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Input something',
          html: '<div class="form-group">' + '<input id="input-field" type="text" class="form-control" />' + '</div>',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function (result) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            type: 'success',
            html: 'You entered',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false

          });
        }).catch(__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.noop);
      }
    }
  }
});

/***/ }),

/***/ "0Bz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0Krs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenu}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosed),expression:"!isClosed"}],staticClass:"nav"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Mp")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("My Profile")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Ep")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Edit Profile")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("S")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Settings")])])])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n           Chet Faker\n           "),_c('b',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "18Zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      }
    };
  },

  methods: {
    notifyVue: function notifyVue(verticalAlign, horizontalAlign) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: {
          template: '<span>Welcome to <b>Paper Dashboard</b> - a beautiful freebie for every web developer.</span>'
        },
        icon: 'ti-gift',
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color]
      });
    }
  }
});

/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "1V4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");







var WorldMap = function WorldMap() {
  return {
    component: __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "1p4m")),
    loading: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Layout_LoadingMainPanel_vue__["a" /* default */],
    delay: 200
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */],
    WorldMap: WorldMap
  },
  data: function data() {
    return {
      statsCards: [{
        type: 'warning',
        icon: 'ti-server',
        title: 'Capacity',
        value: '105GB',
        footerText: 'Updated now',
        footerIcon: 'ti-reload'
      }, {
        type: 'success',
        icon: 'ti-wallet',
        title: 'Revenue',
        value: '$1,345',
        footerText: 'Last day',
        footerIcon: 'ti-calendar'
      }, {
        type: 'danger',
        icon: 'ti-pulse',
        title: 'Errors',
        value: '23',
        footerText: 'In the last hour',
        footerIcon: 'ti-timer'
      }, {
        type: 'info',
        icon: 'ti-twitter-alt',
        title: 'Followers',
        value: '+45',
        footerText: 'Updated now',
        footerIcon: 'ti-reload'
      }],
      earningsChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June'],
          series: [[230, 340, 400, 300, 570, 500, 800]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-green'
          }
        }
      }

    };
  }
});

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2BWB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2SCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('time-line',[_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badgeType":"danger","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-danger",attrs:{"slot":"header"},slot:"header"},[_vm._v("Some title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!!   It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"ti-time"}),_vm._v("\n        11 hours ago via Twitter\n      ")])]),_vm._v(" "),_c('time-line-item',{attrs:{"badgeType":"success","badgeIcon":"ti-check-box"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badgeType":"info","badgeIcon":"ti-credit-card"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n          Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM")]),_vm._v(" "),_c('p',[_vm._v("\n          What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('drop-down',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"slot":"title","href":"#","type":"button","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#here"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#link"}},[_vm._v("Separated link")])])])],1)]),_vm._v(" "),_c('time-line-item',{attrs:{"badgeType":"warning","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-warning",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter also to Kim’s hair and makeup Lorraine jewelry and the whole style squad at Balmain and the Yeezy team. Thank you Anna for the invite thank you to the whole Vogue team")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc15660_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("M/j0");
function injectStyle (ssrContext) {
  __webpack_require__("ZzaD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc15660_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "37ho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__("tlmh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9bfe07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__("alEA");
function injectStyle (ssrContext) {
  __webpack_require__("8vMF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9bfe07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3KWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"tab","error-color":"#EB5E28","color":"#66615B"},on:{"on-complete":_vm.wizardComplete}},[_c('tab-content',{attrs:{"title":"Personal details","before-change":_vm.validateFirstStep,"icon":"ti-user"}},[_c('first-step',{ref:"firstStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Additional Info","before-change":_vm.validateSecondStep,"icon":"ti-settings"}},[_c('second-step',{ref:"secondStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Last step","icon":"ti-check"}},[_c('h2',{staticClass:"text-center text-space"},[_vm._v("Yuhuuu!\n              "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Click on \""),_c('b',[_vm._v("Finish")]),_vm._v("\" to join our community")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Next")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Finish")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3MeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);








__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "3TKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search records","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right","label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-info btn-icon like",on:{"click":function($event){_vm.handleLike(props.$index, props.row)}}},[_c('i',{staticClass:"ti-heart"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){_vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"title"},[_vm._v("Custom table with pagination")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n      We combine "),_c('a',{attrs:{"href":"http://element.eleme.io/#/en-US/component/quickstart","target":"_blank"}},[_vm._v("Element-UI")]),_vm._v("\n      table functionalities together with a custom pagination component\n      which should provide a very good starting point to integrate tables in your application.\n      Check out more functionalities at "),_c('a',{attrs:{"href":"http://element.eleme.io/#/en-US/component/table","target":"_blank"}},[_vm._v("Element-UI table documentation")]),_vm._v(".\n     ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Extended tables")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4JrB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Lu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('register-form',{on:{"on-submit":_vm.onRegisterSubmit}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('login-form',{on:{"on-submit":_vm.onLoginSubmit}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('type-validation-form',{on:{"on-submit":_vm.onTypeValidationSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4d5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLinePage_vue__ = __webpack_require__("NmlF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a99592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLinePage_vue__ = __webpack_require__("2SCm");
function injectStyle (ssrContext) {
  __webpack_require__("G5bo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLinePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a99592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLinePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4qt1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__ = __webpack_require__("negu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb7cf97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__ = __webpack_require__("yKB+");
function injectStyle (ssrContext) {
  __webpack_require__("H0v/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb7cf97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Bu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationForms_vue__ = __webpack_require__("/YGB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee6481b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationForms_vue__ = __webpack_require__("4Lu4");
function injectStyle (ssrContext) {
  __webpack_require__("yqcR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee6481b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("gKTg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5NHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    badgeType: {
      type: String,
      default: 'success'
    },
    badgeIcon: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "5fo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__ = __webpack_require__("pa/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    TaskList: __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__["a" /* default */]
  },
  data: function data() {
    return {
      salesChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 543, 520, 680, 653, 753, 326, 434, 568, 610, 756, 895], [230, 293, 380, 480, 503, 553, 600, 664, 698, 710, 736, 795]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '245px'
        }
      },
      usersChart: {
        data: {
          labels: ['9AM', '12AM', '3PM', '6PM', '9PM', '12PM', '3AM', '6AM'],
          series: [[287, 385, 490, 562, 594, 626, 698, 895, 952], [67, 152, 193, 240, 387, 435, 535, 642, 744], [23, 113, 67, 108, 190, 239, 307, 410, 410]]
        },
        options: {
          low: 0,
          high: 1000,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          showLine: true,
          showPoint: false
        }
      },
      subscriptionsChart: {
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [[60, 50, 30, 50, 70, 60, 90, 100]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-red'
          }
        }
      },
      downloadsChart: {
        data: {
          labels: ['2009', '2010', '2011', '2012', '2013', '2014'],
          series: [[1200, 1000, 3490, 8345, 3256, 2566]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-orange'
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "5uDj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5xQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedForms_vue__ = __webpack_require__("V+Sv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b60d23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedForms_vue__ = __webpack_require__("OWRr");
function injectStyle (ssrContext) {
  __webpack_require__("u9kn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b60d23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "671N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridSystem_vue__ = __webpack_require__("Q8IL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d9a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridSystem_vue__ = __webpack_require__("M/tb");
function injectStyle (ssrContext) {
  __webpack_require__("7p7i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridSystem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d9a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridSystem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6bl1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "77+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users__ = __webpack_require__("J8BY");
















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      var result = this.tableData.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data: function data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['name', 'email', 'age'],
      tableColumns: [{
        prop: 'name',
        label: 'Name',
        minWidth: 200
      }, {
        prop: 'email',
        label: 'Email',
        minWidth: 250
      }, {
        prop: 'age',
        label: 'Age',
        minWidth: 100
      }, {
        prop: 'salary',
        label: 'Salary',
        minWidth: 120
      }],
      tableData: __WEBPACK_IMPORTED_MODULE_12__users__["a" /* default */]
    };
  },

  methods: {
    handleLike: function handleLike(index, row) {
      alert('Your want to like ' + row.name);
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      var indexToDelete = this.tableData.findIndex(function (tableRow) {
        return tableRow.id === row.id;
      });
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  }
});

/***/ }),

/***/ "7p7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8HRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle navbar-toggle-black",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar "}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{staticClass:"btn",attrs:{"to":"/login"}},[_vm._v("\n              Looking to login?\n            ")])],1)])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("\n          Looking to login?\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n          Dashboard\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"register-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"header-text"},[_c('h2',[_vm._v("Paper Dashboard PRO")]),_vm._v(" "),_c('h4',[_vm._v("Register for free and experience the dashboard today.")]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-danger"},[_c('i',{staticClass:"ti ti-user"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Free Account")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-warning"},[_c('i',{staticClass:"ti-bar-chart-alt"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Awesome Performances")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('div',{staticClass:"icon icon-info"},[_c('i',{staticClass:"ti-headphone"})])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h5',[_vm._v("Global Support")]),_vm._v("\n                  Here you can write a feature description for your dashboard, let the users know what is the value that you give them.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-plain"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Your First Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Your Last Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Company"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter email"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password Confirmation"}})])]),_vm._v(" "),_c('div',{staticClass:"footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-danger btn-wd",attrs:{"type":"button"}},[_vm._v("Create Free Account")])])])])])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Cristi Jora")]),_vm._v(".\n            Designed by "),_c('a',{attrs:{"href":"https://www.creative-tim.com/?ref=pdf-vuejs","target":"_blank"}},[_vm._v("Creative Tim")]),_vm._v(".\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8mNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8vMF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9597":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__ = __webpack_require__("E0D1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad77aee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__ = __webpack_require__("v71F");
function injectStyle (ssrContext) {
  __webpack_require__("D/GA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad77aee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9BoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarSharePlugin_vue__ = __webpack_require__("TqFt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6834036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarSharePlugin_vue__ = __webpack_require__("xMeF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarSharePlugin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6834036_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarSharePlugin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9TgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-buttons"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'left')}}},[_vm._v("Top Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'center')}}},[_vm._v("Top Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'right')}}},[_vm._v("Top Right")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'left')}}},[_vm._v("Bottom Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'center')}}},[_vm._v("Bottom Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'right')}}},[_vm._v("Bottom Right")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Notifications")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Custom Vue notifications plugin")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notifications Style")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('span',[_vm._v("This is a plain notification")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_vm._v("This is a notification with close button.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"ti-bell",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"ti-pie-chart",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon and have many lines.\n            You can see that the icon and the close button are always vertically aligned.\n            This is a beautiful notification. So you don't have to worry about the style.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notification states")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Info - ")]),_vm._v(" This is a regular notification made with \".alert-info\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-success"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Success - ")]),_vm._v(" This is a regular notification made with \".alert-success\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Warning - ")]),_vm._v(" This is a regular notification made with \".alert-warning\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-danger"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Danger - ")]),_vm._v(" This is a regular notification made with \".alert-danger\"")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h5',[_vm._v("Notifications Places\n            "),_c('p',{staticClass:"category"},[_vm._v("Click to view notifications")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9gNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("rP9/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88202afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("KtLi");
function injectStyle (ssrContext) {
  __webpack_require__("ifSS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88202afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9nxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A+TP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-timeline card-plain"},[_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"timeline",class:{'timeline-simple': _vm.type === 'simple'}},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A4gK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AuCi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BItS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("aCDv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("yNZB");
function injectStyle (ssrContext) {
  __webpack_require__("V5Z/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BYD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row buttons-with-margin"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p-pagination',{attrs:{"page-count":10},model:{value:(_vm.defaultPagination),callback:function ($$v) {_vm.defaultPagination=$$v},expression:"defaultPagination"}}),_vm._v(" "),_c('p-pagination',{attrs:{"type":"info","page-count":10},model:{value:(_vm.infoPagination),callback:function ($$v) {_vm.infoPagination=$$v},expression:"infoPagination"}})],1)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Colors")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-default btn-fill btn-wd"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-fill btn-wd"},[_vm._v("Primary")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd"},[_vm._v("Info")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-wd"},[_vm._v("Success")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-fill btn-wd"},[_vm._v("Warning")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill btn-wd"},[_vm._v("Danger")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Styles")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-wd"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-wd"},[_vm._v("Fill")]),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-wd"},[_vm._v("Simple")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Buttons with Label and Animation")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-check"})]),_vm._v("\n                Success\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-times"})]),_vm._v("\n                Danger\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-info btn-fill btn-rotate",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-settings"})]),_vm._v("\n                Settings\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-warning btn-fill btn-magnify",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-search"})]),_vm._v("\n                Search\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-default btn-fill btn-move-left",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v("\n                Back\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-default btn-fill btn-move-right",attrs:{"type":"button"}},[_vm._v("\n                Next\n                "),_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sizes")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-lg btn-fill"},[_vm._v("Large")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-fill"},[_vm._v("Small")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-fill"},[_vm._v("X-Small")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Button Group")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Left")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Middle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Right")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("5")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("7")])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Pagination")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Social buttons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Filled")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Simple")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BxWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C38E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","background-color":_vm.sidebarBackground,"active-color":_vm.sidebarTextColor,"sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('user-menu'),_vm._v(" "),_c('form',{staticClass:"navbar-form navbar-left navbar-search-form navbar-search-form-mobile",attrs:{"role":"search"}},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":"Search..."}})])]),_vm._v(" "),_c('mobile-menu')],1),_vm._v(" "),_c('sidebar-share',{attrs:{"color":_vm.sidebarBackground,"text-color":_vm.sidebarTextColor},on:{"update:color":function($event){_vm.sidebarBackground=$event},"update:textColor":function($event){_vm.sidebarTextColor=$event}}}),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CRWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.task.title))]),_vm._v(" "),_c('td',{staticClass:"td-actions text-right"},[_c('div',{staticClass:"table-icons"},[_c('button',{staticClass:"btn btn-info btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Edit Task"},on:{"click":_vm.handleEditClick}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Remove"},on:{"click":_vm.handleDeleteClick}},[_c('i',{staticClass:"ti-close"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","value":"","data-toggle":"checkbox"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "D/GA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DfKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeValidationForm_vue__ = __webpack_require__("+m/k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f39b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeValidationForm_vue__ = __webpack_require__("lS3b");
function injectStyle (ssrContext) {
  __webpack_require__("psw9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeValidationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f39b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeValidationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DjVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dwjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__ = __webpack_require__("Peng");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0576b2fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__ = __webpack_require__("EQjs");
function injectStyle (ssrContext) {
  __webpack_require__("zmm5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMaps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0576b2fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMaps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E0D1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        company: 'Paper Dashboard',
        username: 'michael23',
        email: '',
        lastName: 'Faker',
        address: 'Melbourne, Australia',
        city: 'melbourne',
        postalCode: '',
        aboutMe: 'Oh so, your weak rhyme. You doubt I\'ll bother, reading into it.I\'ll probably won\'t, left to my own devicesBut that\'s the difference in our opinions.'
      }
    };
  },

  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user));
    }
  }
});

/***/ }),

/***/ "EQjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-map"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Satellite Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map map-big",attrs:{"id":"satelliteMap"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Regular Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map",attrs:{"id":"regularMap"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Custom Skin & Settings Map")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"map",attrs:{"id":"customSkinMap"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FQVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},_vm._l((_vm.details),function(info,index){return _c('div',{class:_vm.getClasses(index)},[_c('h5',[_vm._v(_vm._s(info.title)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(info.subTitle))])])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":"static/img/background.jpg","alt":"..."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar border-white",attrs:{"src":"static/img/faces/face-2.jpg","alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Chet Faker\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v("@chetfaker")])])])]),_vm._v(" "),_c('p',{staticClass:"description text-center"},[_vm._v("\n      \"I like the way you work it\n      "),_c('br'),_vm._v(" No diggity\n      "),_c('br'),_vm._v(" I wanna bag it up\"\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Dashboard',
  icon: 'ti-panel',
  collapsed: false,
  children: [{
    name: 'Overview',
    path: '/admin/overview'
  }, {
    name: 'Stats',
    path: '/admin/stats'
  }]
}, {
  name: 'Components',
  icon: 'ti-package',
  children: [{
    name: 'Buttons',
    path: '/components/buttons'
  }, {
    name: 'Grid System',
    path: '/components/grid-system'
  }, {
    name: 'Panels',
    path: '/components/panels'
  }, {
    name: 'Sweet Alert',
    path: '/components/sweet-alert'
  }, {
    name: 'Notifications',
    path: '/components/notifications'
  }, {
    name: 'Icons',
    path: '/components/icons'
  }, {
    name: 'Typography',
    path: '/components/typography'
  }]
}, {
  name: 'Forms',
  icon: 'ti-clipboard',
  children: [{
    name: 'Regular Forms',
    path: '/forms/regular'
  }, {
    name: 'Extended Forms',
    path: '/forms/extended'
  }, {
    name: 'Validation Forms',
    path: '/forms/validation'
  }, {
    name: 'Wizard',
    path: '/forms/wizard'
  }]
}, {
  name: 'Table List',
  icon: 'ti-view-list-alt',
  collapsed: true,
  children: [{
    name: 'Regular Tables',
    path: '/table-list/regular'
  }, {
    name: 'Extended Tables',
    path: '/table-list/extended'
  }, {
    name: 'Paginated Tables',
    path: '/table-list/paginated'
  }]
}, {
  name: 'Maps',
  icon: 'ti-map',
  children: [{
    name: 'Google Maps',
    path: '/maps/google'
  }, {
    name: 'Full Screen Maps',
    path: '/maps/full-screen'
  }, {
    name: 'Vector Maps',
    path: '/maps/vector-map'
  }]
}, {
  name: 'Charts',
  icon: 'ti-gift',
  path: '/charts'
}, {
  name: 'Calendar',
  icon: 'ti-calendar',
  path: '/calendar'
}, {
  name: 'Pages',
  icon: 'ti-gift',
  children: [{
    name: 'User Page',
    path: '/pages/user'
  }, {
    name: 'Timeline Page',
    path: '/pages/timeline'
  }, {
    name: 'Login Page',
    path: '/login'
  }, {
    name: 'Register Page',
    path: '/register'
  }, {
    name: 'Lock Page',
    path: '/lock'
  }]
}]);

/***/ }),

/***/ "G5bo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GJqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GdNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");


var VectorMap = function VectorMap() {
  return {
    component: __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "jrBO")),
    loading: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__["a" /* default */],
    delay: 200
  };
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VectorMap: VectorMap
  }
});

/***/ }),

/***/ "H0v/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H2oj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sweet Alert 2")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-sweet-alerts"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Basic example")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('basic')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A title with a text under")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('title-and-text')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A success message")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('success-message')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Custom HTML description")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('custom-html')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A warning message, with a function attached to the \"Confirm\" Button...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('warning-message-and-confirmation')}}},[_vm._v("\n              Try me!\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("...and by passing a parameter, you can execute something else for \"Cancel\"")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('warning-message-and-cancel')}}},[_vm._v("Try me!\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A message with auto close timer set to 2 seconds")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('auto-close')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Modal window with input field")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('input-field')}}},[_vm._v("Try me!")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("A beautiful plugin, that replace the classic alert, Handcrafted by our friend "),_c('a',{attrs:{"target":"_blank","href":"https://twitter.com/t4t5"}},[_vm._v("Tristan Edwards")]),_vm._v(". Please check out the "),_c('a',{attrs:{"href":"http://limonte.github.io/sweetalert2/","target":"_blank"}},[_vm._v("full documentation.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HHnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4773f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("MGBx");
function injectStyle (ssrContext) {
  __webpack_require__("Wdwa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4773f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hyh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"1"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"2"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"3"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card card-plain"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"1"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"2"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"3"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('vue-tabs',{staticClass:"row",attrs:{"direction":"vertical","value":"Description"}},[_c('v-tab',{attrs:{"title":"Info"}},[_c('p',[_vm._v("\n              Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.")]),_vm._v(" "),_c('p',[_vm._v("\n                It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Description"}},[_c('p',[_vm._v("\n                The first thing you notice when you hold the phone is how great it feels in your hand. The cover glass curves down around the sides to meet the anodized aluminum enclosure in a remarkable, simplified design.")]),_vm._v(" "),_c('p',[_vm._v("\n                There are no distinct edges. No gaps. Just a smooth, seamless bond of metal and glass that feels like one continuous surface.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Messages"}},[_c('p',[_vm._v("\n                It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.")]),_vm._v(" "),_c('p',[_vm._v("\n                Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Support"}},[_c('p',[_vm._v("\n                From the seamless transition of glass and metal to the streamlined profile, every detail was carefully considered to enhance your experience. So while its display is larger, the phone feels just right.")]),_vm._v("\n              It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.\n            ")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Extra"}},[_vm._v("\n              Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.\n              It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.\n            ")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(3),_vm._v(" "),_c('vue-tabs',{staticClass:"card-content"},[_c('v-tab',{attrs:{"title":"Home"}},[_vm._v("\n            Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.\n          ")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Profile"}},[_vm._v("Here is your profile.")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Messages"}},[_vm._v("Here are your messages.")])],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Collapsible Accordion")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bootstrap default style")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Collapsible Accordion on Plain Card")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bootstrap default style")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tabs")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Vertical tabs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tabs")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Plain text tabs")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IWrx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IsOm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J0Sr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4xn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J8BY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 2,
  'name': 'Mr. Enid Von PhD',
  'nickname': 'alias',
  'email': 'pollich.cecilia@example.com',
  'salary': '35978.00',
  'age': 26
}, {
  'id': 3,
  'name': 'Colton Koch',
  'nickname': 'id',
  'email': 'little.myrna@example.net',
  'salary': '26278.00',
  'age': 48
}, {
  'id': 4,
  'name': 'Gregory Vandervort',
  'nickname': 'vel',
  'email': 'dock47@example.org',
  'salary': '25537.00',
  'age': 27
}, {
  'id': 5,
  'name': 'Miss Rahsaan Heaney IV',
  'nickname': 'qui',
  'email': 'ugrady@example.org',
  'salary': '49003.00',
  'age': 21
}, {
  'id': 6,
  'name': 'Ms. Crystel Zemlak IV',
  'nickname': 'reiciendis',
  'email': 'amari.rau@example.com',
  'salary': '12383.00',
  'age': 48
}, {
  'id': 7,
  'name': 'Nona McDermott',
  'nickname': 'quaerat',
  'email': 'adrien.baumbach@example.org',
  'salary': '18512.00',
  'age': 31
}, {
  'id': 8,
  'name': 'Miss Genoveva Murazik V',
  'nickname': 'rerum',
  'email': 'ohettinger@example.net',
  'salary': '31209.00',
  'age': 28
}, {
  'id': 9,
  'name': 'Beulah Huels',
  'nickname': 'non',
  'email': 'stefan99@example.com',
  'salary': '36920.00',
  'age': 53
}, {
  'id': 10,
  'name': 'Zoe Klein',
  'nickname': 'ex',
  'email': 'ejacobson@example.org',
  'salary': '35616.00',
  'age': 27
}, {
  'id': 11,
  'name': 'Vickie Kiehn',
  'nickname': 'assumenda',
  'email': 'ayost@example.com',
  'salary': '30790.00',
  'age': 29
}, {
  'id': 12,
  'name': 'Elwyn Herzog',
  'nickname': 'praesentium',
  'email': 'ckassulke@example.net',
  'salary': '35785.00',
  'age': 27
}, {
  'id': 13,
  'name': 'Selena Hettinger',
  'nickname': 'et',
  'email': 'bashirian.hyman@example.net',
  'salary': '31836.00',
  'age': 35
}, {
  'id': 14,
  'name': 'Edwin Beier',
  'nickname': 'eos',
  'email': 'janis71@example.org',
  'salary': '11902.00',
  'age': 38
}, {
  'id': 15,
  'name': 'Lexi Braun MD',
  'nickname': 'autem',
  'email': 'dusty74@example.net',
  'salary': '11927.00',
  'age': 45
}, {
  'id': 16,
  'name': 'Jovany Spencer',
  'nickname': 'fugit',
  'email': 'gbogisich@example.org',
  'salary': '44686.00',
  'age': 43
}, {
  'id': 17,
  'name': 'Prof. Maci Anderson DVM',
  'nickname': 'dolorem',
  'email': 'btorp@example.com',
  'salary': '25055.00',
  'age': 29
}, {
  'id': 18,
  'name': 'Joel Kulas MD',
  'nickname': 'sed',
  'email': 'phoebe.sauer@example.org',
  'salary': '11650.00',
  'age': 24
}, {
  'id': 19,
  'name': 'Mr. Dawson Greenholt',
  'nickname': 'nostrum',
  'email': 'asawayn@example.org',
  'salary': '46962.00',
  'age': 53
}, {
  'id': 20,
  'name': 'Prof. Lloyd Green',
  'nickname': 'velit',
  'email': 'laila.hintz@example.org',
  'salary': '12928.00',
  'age': 46
}, {
  'id': 21,
  'name': 'Shayna Morar',
  'nickname': 'rerum',
  'email': 'wfay@example.org',
  'salary': '22638.00',
  'age': 26
}, {
  'id': 22,
  'name': 'Krista Schulist',
  'nickname': 'qui',
  'email': 'gregoria.jakubowski@example.com',
  'salary': '49345.00',
  'age': 42
}, {
  'id': 23,
  'name': 'Leone Lemke',
  'nickname': 'repellat',
  'email': 'ltorphy@example.com',
  'salary': '17560.00',
  'age': 42
}, {
  'id': 24,
  'name': 'Dr. Willie Kemmer II',
  'nickname': 'quasi',
  'email': 'ivy51@example.net',
  'salary': '35370.00',
  'age': 30
}, {
  'id': 25,
  'name': 'Deonte Lebsack',
  'nickname': 'nesciunt',
  'email': 'alisa83@example.net',
  'salary': '32725.00',
  'age': 24
}, {
  'id': 26,
  'name': 'Prof. Shayne Nader',
  'nickname': 'voluptas',
  'email': 'bosco.shaina@example.net',
  'salary': '9844.00',
  'age': 23
}, {
  'id': 27,
  'name': 'Prof. Kennith Kertzmann',
  'nickname': 'alias',
  'email': 'satterfield.jonathan@example.com',
  'salary': '41950.00',
  'age': 25
}, {
  'id': 28,
  'name': 'Miss Meagan O\'Keefe',
  'nickname': 'corporis',
  'email': 'tracy.barrows@example.com',
  'salary': '41803.00',
  'age': 50
}, {
  'id': 29,
  'name': 'Prof. Edward Pagac MD',
  'nickname': 'quia',
  'email': 'gerhard65@example.org',
  'salary': '22896.00',
  'age': 43
}, {
  'id': 30,
  'name': 'Samantha Weissnat',
  'nickname': 'est',
  'email': 'crystel66@example.net',
  'salary': '18805.00',
  'age': 43
}, {
  'id': 31,
  'name': 'Dr. Gilbert Ward',
  'nickname': 'dolorum',
  'email': 'sandrine06@example.net',
  'salary': '16644.00',
  'age': 32
}, {
  'id': 32,
  'name': 'Mike West',
  'nickname': 'laudantium',
  'email': 'jborer@example.net',
  'salary': '35728.00',
  'age': 42
}, {
  'id': 33,
  'name': 'Prof. Isabell Cruickshank I',
  'nickname': 'recusandae',
  'email': 'ondricka.lurline@example.org',
  'salary': '44574.00',
  'age': 35
}, {
  'id': 34,
  'name': 'Prof. Lonny Rath',
  'nickname': 'nihil',
  'email': 'rfeest@example.net',
  'salary': '19949.00',
  'age': 48
}, {
  'id': 35,
  'name': 'Santina Medhurst MD',
  'nickname': 'suscipit',
  'email': 'ila24@example.net',
  'salary': '36323.00',
  'age': 51
}, {
  'id': 36,
  'name': 'Jeff Lehner',
  'nickname': 'quo',
  'email': 'jarred77@example.com',
  'salary': '48462.00',
  'age': 42
}, {
  'id': 37,
  'name': 'Samanta Pfeffer',
  'nickname': 'officia',
  'email': 'fgoyette@example.net',
  'salary': '19601.00',
  'age': 42
}, {
  'id': 38,
  'name': 'Ofelia Torp',
  'nickname': 'a',
  'email': 'ericka44@example.net',
  'salary': '33149.00',
  'age': 35
}, {
  'id': 39,
  'name': 'Mrs. Margarete Raynor',
  'nickname': 'quia',
  'email': 'jlegros@example.net',
  'salary': '21951.00',
  'age': 40
}, {
  'id': 40,
  'name': 'Mr. Brant Howell V',
  'nickname': 'perspiciatis',
  'email': 'franecki.gerald@example.org',
  'salary': '41552.00',
  'age': 53
}, {
  'id': 41,
  'name': 'Reilly Ruecker DVM',
  'nickname': 'ad',
  'email': 'ldeckow@example.net',
  'salary': '22709.00',
  'age': 42
}, {
  'id': 42,
  'name': 'Zachery McDermott',
  'nickname': 'molestiae',
  'email': 'gladyce84@example.com',
  'salary': '32354.00',
  'age': 25
}, {
  'id': 43,
  'name': 'Heloise Kulas',
  'nickname': 'aut',
  'email': 'kessler.helen@example.net',
  'salary': '45086.00',
  'age': 54
}, {
  'id': 44,
  'name': 'Norma Dibbert',
  'nickname': 'amet',
  'email': 'eudora36@example.net',
  'salary': '15661.00',
  'age': 46
}, {
  'id': 45,
  'name': 'Immanuel Auer',
  'nickname': 'quia',
  'email': 'halvorson.theodora@example.org',
  'salary': '15862.00',
  'age': 39
}, {
  'id': 46,
  'name': 'Lamont Borer',
  'nickname': 'expedita',
  'email': 'trantow.neoma@example.com',
  'salary': '12544.00',
  'age': 25
}, {
  'id': 47,
  'name': 'Brooke Purdy',
  'nickname': 'cupiditate',
  'email': 'bhermiston@example.net',
  'salary': '14457.00',
  'age': 50
}, {
  'id': 48,
  'name': 'Dr. Leo Dach',
  'nickname': 'et',
  'email': 'camila.ward@example.com',
  'salary': '40278.00',
  'age': 49
}, {
  'id': 49,
  'name': 'Krystal Langosh',
  'nickname': 'voluptatum',
  'email': 'pacocha.yesenia@example.org',
  'salary': '9305.00',
  'age': 34
}, {
  'id': 50,
  'name': 'Florence Greenfelder',
  'nickname': 'odit',
  'email': 'kenyatta.oconnell@example.com',
  'salary': '36980.00',
  'age': 38
}]);

/***/ }),

/***/ "JElF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_KEY; });
var API_KEY = 'AIzaSyAamVCoyQ4AuvBpxVRMs9P-HFkfPVQj0Kw';

/***/ }),

/***/ "JW7q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JhHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__ = __webpack_require__("3MeN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__ = __webpack_require__("i/rH");
function injectStyle (ssrContext) {
  __webpack_require__("sk1x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KWr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarRoute_vue__ = __webpack_require__("atjs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f88b2c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarRoute_vue__ = __webpack_require__("bxZR");
function injectStyle (ssrContext) {
  __webpack_require__("J4xn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarRoute_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f88b2c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarRoute_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kakj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTables_vue__ = __webpack_require__("77+S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475d5aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTables_vue__ = __webpack_require__("3TKg");
function injectStyle (ssrContext) {
  __webpack_require__("VEgf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475d5aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KtLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5"},[_c('user-card'),_vm._v(" "),_c('members-card')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-7"},[_c('edit-profile-form')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KyZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [{
        id: 1,
        name: 'Dakota Rice',
        salary: '$36.738',
        country: 'Niger',
        city: 'Oud-Turnhout'
      }, {
        id: 2,
        name: 'Minerva Hooper',
        salary: '$23,789',
        country: 'Curaçao',
        city: 'Sinaai-Waas'
      }, {
        id: 3,
        name: 'Sage Rodriguez',
        salary: '$56,142',
        country: 'Netherlands',
        city: 'Baileux'
      }, {
        id: 4,
        name: 'Philip Chaney',
        salary: '$38,735',
        country: 'Korea, South',
        city: 'Overland Park'
      }, {
        id: 5,
        name: 'Doris Greene',
        salary: '$63,542',
        country: 'Malawi',
        city: 'Feldkirchen in Kärnten'
      }]
    };
  },

  methods: {
    tableRowClassName: function tableRowClassName(row, index) {
      if (index === 0) {
        return 'success';
      } else if (index === 2) {
        return 'info';
      } else if (index === 4) {
        return 'danger';
      } else if (index === 6) {
        return 'warning';
      }
      return '';
    }
  }
});

/***/ }),

/***/ "LQk8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LRfs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LdiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Login")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Login Form\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M/j0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-minimize"},[_c('button',{staticClass:"btn btn-fill btn-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'})])]),_vm._v(" "),_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(this.$route.name))])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',{staticClass:"open"},[_c('router-link',{staticClass:"dropdown-toggle btn-magnify",attrs:{"to":"/admin/stats","data-toggle":"dropdown"}},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "),_c('p',[_vm._v("Stats")])])],1),_vm._v(" "),_c('drop-down',{attrs:{"tag":"li","title":"5","icon":"ti-bell"}},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Notification 1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Notification 2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Notification 3")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Notification 4")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Another notification")])])]),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"btn-rotate",attrs:{"to":"/admin/overview"}},[_c('i',{staticClass:"ti-settings"})])],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"navbar-form navbar-left navbar-search-form",attrs:{"role":"search"}},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":"Search..."}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M/tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"title"},[_vm._v("XS Grid\n      "),_c('small',[_vm._v("Always Horizontal")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("SM Grid\n      "),_c('small',[_vm._v("Collapsed at 768px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("MD Grid\n      "),_c('small',[_vm._v("Collapsed at 992px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("LG Grid\n      "),_c('small',[_vm._v("Collapsed at 1200px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Mixed Grid\n      "),_c('small',[_vm._v("Showing different sizes on different screens")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Offset Grid\n      "),_c('small',[_vm._v("Adding some space when needed")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-md-offset-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-3 col-md-offset-6")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-1"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4 col-md-offset-1")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4 col-md-offset-2")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-6 col-md-offset-3")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Paragraphs")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M0iJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410692ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("bAsJ");
function injectStyle (ssrContext) {
  __webpack_require__("YvUw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410692ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MGBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive || _vm.$route.fullPath.startsWith(_vm.link.path)},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",[_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45cdef76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("kCrS");
function injectStyle (ssrContext) {
  __webpack_require__("+sal")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45cdef76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Paper Dashboard Pro'
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/vue-logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  },
  methods: {
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "ieps"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "Fiov"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "Mi7u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gloablComponents__ = __webpack_require__("iXuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sidebarLinks__ = __webpack_require__("FiZY");






















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9__gloablComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_16__sidebarLinks__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_12__routes_routes__["a" /* default */],
  linkActiveClass: 'active'
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: 'UA-46172202-9',
  router: router,
  autoTracking: {
    pageviewOnLoad: false
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__App_vue__["a" /* default */]);
  },
  router: router
});

/***/ }),

/***/ "NmlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard_Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Dashboard_Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Dashboard_Stats_TimeLineItem_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Nrso":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please give us more details about your platform.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Your Website")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.website),expression:"modelValidations.website"},{name:"model",rawName:"v-model",value:(_vm.model.website),expression:"model.website"}],staticClass:"form-control",attrs:{"type":"text","name":"website","url":"true","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "website", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.website.invalid),expression:"website.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('website'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Framework Type")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.framework),expression:"model.framework"}],staticClass:"form-control",attrs:{"type":"text","name":"framework","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.framework)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "framework", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Language\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.language),expression:"modelValidations.language"},{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"}],staticClass:"form-control",attrs:{"name":"language"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- language -")]),_vm._v(" "),_c('option',{attrs:{"value":"ms"}},[_vm._v("Bahasa Melayu")]),_vm._v(" "),_c('option',{attrs:{"value":"ca"}},[_vm._v("Català")]),_vm._v(" "),_c('option',{attrs:{"value":"da"}},[_vm._v("Dansk")]),_vm._v(" "),_c('option',{attrs:{"value":"de"}},[_vm._v("Deutsch")]),_vm._v(" "),_c('option',{attrs:{"value":"en"}},[_vm._v("English")]),_vm._v(" "),_c('option',{attrs:{"value":"es"}},[_vm._v("Español")]),_vm._v(" "),_c('option',{attrs:{"value":"el"}},[_vm._v("Eλληνικά")]),_vm._v(" "),_c('option',{attrs:{"value":"fr"}},[_vm._v("Français")]),_vm._v(" "),_c('option',{attrs:{"value":"it"}},[_vm._v("Italiano")]),_vm._v(" "),_c('option',{attrs:{"value":"hu"}},[_vm._v("Magyar")]),_vm._v(" "),_c('option',{attrs:{"value":"nl"}},[_vm._v("Nederlands")]),_vm._v(" "),_c('option',{attrs:{"value":"no"}},[_vm._v("Norsk")]),_vm._v(" "),_c('option',{attrs:{"value":"pl"}},[_vm._v("Polski")]),_vm._v(" "),_c('option',{attrs:{"value":"pt"}},[_vm._v("Português")]),_vm._v(" "),_c('option',{attrs:{"value":"fi"}},[_vm._v("Suomi")]),_vm._v(" "),_c('option',{attrs:{"value":"sv"}},[_vm._v("Svenska")]),_vm._v(" "),_c('option',{attrs:{"value":"tr"}},[_vm._v("Türkçe")]),_vm._v(" "),_c('option',{attrs:{"value":"is"}},[_vm._v("Íslenska")]),_vm._v(" "),_c('option',{attrs:{"value":"cs"}},[_vm._v("Čeština")]),_vm._v(" "),_c('option',{attrs:{"value":"ru"}},[_vm._v("Русский")]),_vm._v(" "),_c('option',{attrs:{"value":"th"}},[_vm._v("ภาษาไทย")]),_vm._v(" "),_c('option',{attrs:{"value":"zh"}},[_vm._v("中文 (简体)")]),_vm._v(" "),_c('option',{attrs:{"value":"zh-TW"}},[_vm._v("中文 (繁體)")]),_vm._v(" "),_c('option',{attrs:{"value":"ja"}},[_vm._v("日本語")]),_vm._v(" "),_c('option',{attrs:{"value":"ko"}},[_vm._v("한국어")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.language.invalid),expression:"language.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('language'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Bootstrap Version\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.bootstrapVersion),expression:"modelValidations.bootstrapVersion"},{name:"model",rawName:"v-model",value:(_vm.model.bootstrapVersion),expression:"model.bootstrapVersion"}],staticClass:"form-control",attrs:{"name":"cities"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "bootstrapVersion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- version -")]),_vm._v(" "),_c('option',{attrs:{"value":"1.1"}},[_vm._v("Bootstrap 1.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("Bootstrap 2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("Bootstrap 3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("Bootstrap 4.0(alpha)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Price")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.price),expression:"model.price"}],staticClass:"form-control",attrs:{"type":"text","name":"price","placeholder":"ex: 19.00"},domProps:{"value":(_vm.model.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "price", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OWRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extended-forms"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Datetime Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select date and time","picker-options":_vm.pickerOptions1},model:{value:(_vm.dateTimePicker),callback:function ($$v) {_vm.dateTimePicker=$$v},expression:"dateTimePicker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Date Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"Pick a day","picker-options":_vm.pickerOptions1},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Time Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '23:59'
              },"placeholder":"Select time"},model:{value:(_vm.timePicker),callback:function ($$v) {_vm.timePicker=$$v},expression:"timePicker"}})],1)])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Switches")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Default")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.switches.defaultOn),callback:function ($$v) {_vm.$set(_vm.switches, "defaultOn", $$v)},expression:"switches.defaultOn"}}),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.switches.defaultOff),callback:function ($$v) {_vm.$set(_vm.switches, "defaultOff", $$v)},expression:"switches.defaultOff"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Plain")]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.plainOn),callback:function ($$v) {_vm.$set(_vm.switches, "plainOn", $$v)},expression:"switches.plainOn"}}),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.plainOff),callback:function ($$v) {_vm.$set(_vm.switches, "plainOff", $$v)},expression:"switches.plainOff"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("With Icons")]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.withIconsOn),callback:function ($$v) {_vm.$set(_vm.switches, "withIconsOn", $$v)},expression:"switches.withIconsOn"}},[_c('i',{staticClass:"fa fa-check",attrs:{"slot":"on"},slot:"on"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"slot":"off"},slot:"off"})]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.withIconsOff),callback:function ($$v) {_vm.$set(_vm.switches, "withIconsOff", $$v)},expression:"switches.withIconsOff"}},[_c('i',{staticClass:"fa fa-check",attrs:{"slot":"on"},slot:"on"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"slot":"off"},slot:"off"})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h4',{staticClass:"card-title"},[_vm._v("Checkboxes")]),_vm._v(" "),_c('p-checkbox',{attrs:{"checked":false}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"checked":true}},[_vm._v("Checked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":"","checked":false}},[_vm._v("Disabled unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":"","checked":true}},[_vm._v("Disabled checked")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h4',{staticClass:"card-title"},[_vm._v("Radio")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.enabledRadio),callback:function ($$v) {_vm.enabledRadio=$$v},expression:"enabledRadio"}},[_vm._v("Radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.enabledRadio),callback:function ($$v) {_vm.enabledRadio=$$v},expression:"enabledRadio"}},[_vm._v("Radio is on")]),_vm._v(" "),_c('p-radio',{attrs:{"disabled":"","label":"1"},model:{value:(_vm.disabledRadio),callback:function ($$v) {_vm.disabledRadio=$$v},expression:"disabledRadio"}},[_vm._v("Disabled radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"disabled":"","label":"2"},model:{value:(_vm.disabledRadio),callback:function ($$v) {_vm.disabledRadio=$$v},expression:"disabledRadio"}},[_vm._v("Disabled radio is on")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tags")]),_vm._v(" "),_vm._l((_vm.tags.dynamicTags),function(tag){return _c('el-tag',{key:tag,attrs:{"type":"primary","closable":true,"close-transition":false},on:{"close":function($event){_vm.handleClose(tag)}}},[_vm._v("\n            "+_vm._s(tag)+"\n          ")])}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tags.inputValue),expression:"tags.inputValue"}],ref:"saveTagInput",staticClass:"form-control input-new-tag",attrs:{"type":"text","placeholder":"Add new tag","size":"mini"},domProps:{"value":(_vm.tags.inputValue)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleInputConfirm($event)},"blur":_vm.handleInputConfirm,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tags, "inputValue", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Progress Bars")]),_vm._v(" "),_c('p-progress',{attrs:{"value":30}}),_vm._v(" "),_c('p-progress',{attrs:{"value":60,"type":"info"}}),_vm._v(" "),_c('p-progress',{attrs:{"values":[{type:'success', value:35},{type:'warning', value:20}, {type:'danger', value: 10}]}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Sliders")]),_vm._v(" "),_c('el-slider',{staticClass:"slider-success",model:{value:(_vm.sliders.simple),callback:function ($$v) {_vm.$set(_vm.sliders, "simple", $$v)},expression:"sliders.simple"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-slider',{staticClass:"slider-info",attrs:{"max":100,"range":""},model:{value:(_vm.sliders.rangeSlider),callback:function ($$v) {_vm.$set(_vm.sliders, "rangeSlider", $$v)},expression:"sliders.rangeSlider"}})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Customisable Select")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-danger",attrs:{"size":"large","placeholder":"Single Select"},model:{value:(_vm.selects.simple),callback:function ($$v) {_vm.$set(_vm.selects, "simple", $$v)},expression:"selects.simple"}},_vm._l((_vm.selects.countries),function(option){return _c('el-option',{key:option.label,staticClass:"select-danger",attrs:{"value":option.value,"label":option.label}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-primary",attrs:{"multiple":"","size":"large","placeholder":"Multiple Select"},model:{value:(_vm.selects.multiple),callback:function ($$v) {_vm.$set(_vm.selects, "multiple", $$v)},expression:"selects.multiple"}},_vm._l((_vm.selects.countries),function(option){return _c('el-option',{key:option.label,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Dropdown")]),_vm._v(" "),_c('drop-down',[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                  Regular\n                  "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("One more separated link")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Dropup")]),_vm._v(" "),_c('drop-down',{attrs:{"slide":"up"}},[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                  Regular\n                  "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("One more separated link")])])])],1)])])]),_vm._v(" "),_c('br'),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("+lQa");
function injectStyle (ssrContext) {
  __webpack_require__("AuCi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PAWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularForms_vue__ = __webpack_require__("pfXf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aaaf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularForms_vue__ = __webpack_require__("r2+i");
function injectStyle (ssrContext) {
  __webpack_require__("eFVZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aaaf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PGBT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Peng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__API_KEY__ = __webpack_require__("JElF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_google_maps__);




__WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.KEY = __WEBPACK_IMPORTED_MODULE_0__API_KEY__["a" /* API_KEY */];

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initSattelliteMap: function initSattelliteMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 3,
        scrollwheel: false,
        center: myLatlng,
        mapTypeId: window.google.maps.MapTypeId.SATELLITE
      };

      var map = new window.google.maps.Map(document.getElementById('satelliteMap'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Satellite Map!'
      });
      marker.setMap(map);
    },
    initRegularMap: function initRegularMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 8,
        center: myLatlng,
        scrollwheel: false };

      var map = new window.google.maps.Map(document.getElementById('regularMap'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Regular Map!'
      });

      marker.setMap(map);
    },
    initCustomSkinMap: function initCustomSkinMap(google) {
      var myLatlng = new google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 13,
        center: myLatlng,
        scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [{
          'featureType': 'water',
          'stylers': [{ 'saturation': 43 }, { 'lightness': -11 }, { 'hue': '#0088ff' }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.fill',
          'stylers': [{ 'hue': '#ff0000' }, { 'saturation': -100 }, { 'lightness': 99 }]
        }, {
          'featureType': 'road',
          'elementType': 'geometry.stroke',
          'stylers': [{ 'color': '#808080' }, { 'lightness': 54 }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ece2d9' }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.fill',
          'stylers': [{ 'color': '#ccdca1' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.fill',
          'stylers': [{ 'color': '#767676' }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.stroke',
          'stylers': [{ 'color': '#ffffff' }]
        }, { 'featureType': 'poi', 'stylers': [{ 'visibility': 'off' }] }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry.fill',
          'stylers': [{ 'visibility': 'on' }, { 'color': '#b8cb93' }]
        }, { 'featureType': 'poi.park', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.sports_complex',
          'stylers': [{ 'visibility': 'on' }]
        }, { 'featureType': 'poi.medical', 'stylers': [{ 'visibility': 'on' }] }, {
          'featureType': 'poi.business',
          'stylers': [{ 'visibility': 'simplified' }]
        }]
      };

      var map = new google.maps.Map(document.getElementById('customSkinMap'), mapOptions);

      var marker = new google.maps.Marker({
        position: myLatlng,
        title: 'Custom Skin & Settings Map!'
      });

      marker.setMap(map);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_google_maps___default.a.load(function (google) {
      _this.initSattelliteMap(google);
      _this.initRegularMap(google);
      _this.initCustomSkinMap(google);
    });
  }
});

/***/ }),

/***/ "Pfw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("bJ0t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_132f20c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("LdiV");
function injectStyle (ssrContext) {
  __webpack_require__("DjVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_132f20c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PzXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tableData: [{
        name: 'Andrew Mike',
        job: 'Develop',
        salary: '€ 99,225',
        active: false
      }, {
        name: 'John Doe',
        job: 'Design',
        salary: '€ 89,241',
        active: false
      }, {
        name: 'Alex Mike',
        job: 'Design',
        salary: '€ 92,144',
        active: false
      }, {
        name: 'Mike Monday',
        job: 'Marketing',
        salary: '€ 49,990',
        active: true
      }, {
        name: 'Paul dickens',
        job: 'Communication',
        salary: '€ 69,201',
        active: true
      }],
      productsTable: [{
        image: 'static/img/tables/agenda.png',
        title: 'Notebook',
        subTitle: 'Most beautiful agenda for the office.',
        price: 49,
        quantity: 1
      }, {
        image: 'static/img/tables/stylus.jpg',
        title: 'Stylus',
        subTitle: 'Design is not just what it looks like and feels like. Design is how it works.',
        price: 499,
        quantity: 2
      }, {
        image: 'static/img/tables/evernote.png',
        title: 'Evernote iPad Stander',
        subTitle: 'A groundbreaking Retina display. All-flash architecture. Fourth-generation Intel processors.',
        price: 799,
        quantity: 1
      }]
    };
  },

  methods: {
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    },
    getSummaries: function getSummaries(param) {
      var _this = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Total';
        } else if (index < columns.length - 1) {
          sums[index] = '';
        } else {
          var sum = 0;
          _this.productsTable.forEach(function (obj) {
            sum += obj.quantity * obj.price;
          });
          sums[index] = '\u20AC ' + sum;
        }
      });
      return sums;
    }
  }
});

/***/ }),

/***/ "Q8IL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0806a837_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("RGwF");
function injectStyle (ssrContext) {
  __webpack_require__("pPMM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0806a837_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RGwF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text logo-mini",attrs:{"href":"https://www.creative-tim.com/product/vue-paper-dashboard-pro"}},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]),_vm._v(" "),_c('a',{staticClass:"simple-text logo-normal",attrs:{"href":"https://www.creative-tim.com/vue-paper-dashboard-pro"}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})}),1)}))],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RM11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("S8VE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07338075_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("swfc");
function injectStyle (ssrContext) {
  __webpack_require__("XaJ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07338075_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RUAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vector-map')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RXFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "Rrpr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email'])),
  data: function data() {
    return {
      model: {
        firstName: '',
        lastName: '',
        email: ''
      },
      modelValidations: {
        firstName: {
          min: 5
        },
        lastName: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "S8VE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "SKQV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SUPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_maps__ = __webpack_require__("lMsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__API_KEY__ = __webpack_require__("JElF");




__WEBPACK_IMPORTED_MODULE_0_google_maps___default.a.KEY = __WEBPACK_IMPORTED_MODULE_1__API_KEY__["a" /* API_KEY */];

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    initMap: function initMap(google) {
      var myLatlng = new window.google.maps.LatLng(40.748817, -73.985428);
      var mapOptions = {
        zoom: 8,
        center: myLatlng,
        scrollwheel: false };

      var map = new window.google.maps.Map(document.getElementById('map'), mapOptions);

      var marker = new window.google.maps.Marker({
        position: myLatlng,
        title: 'Regular Map!'
      });

      marker.setMap(map);
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_google_maps___default.a.load(function (google) {
      _this.initMap(google);
    });
  }
});

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_Overview_vue__ = __webpack_require__("uFAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Dashboard_Stats_vue__ = __webpack_require__("+GID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Pages_UserProfile_vue__ = __webpack_require__("9gNx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Pages_TimeLinePage_vue__ = __webpack_require__("4d5k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Pages_Login_vue__ = __webpack_require__("WI53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Pages_Register_vue__ = __webpack_require__("sMOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Pages_Lock_vue__ = __webpack_require__("duHq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Components_Buttons_vue__ = __webpack_require__("fP9K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Components_GridSystem_vue__ = __webpack_require__("671N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Components_Panels_vue__ = __webpack_require__("i0bx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Components_SweetAlert_vue__ = __webpack_require__("ribu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Components_Notifications_vue__ = __webpack_require__("+VxC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Components_Icons_vue__ = __webpack_require__("RM11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Components_Typography_vue__ = __webpack_require__("f6/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Forms_RegularForms_vue__ = __webpack_require__("PAWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Forms_ExtendedForms_vue__ = __webpack_require__("5xQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Forms_ValidationForms_vue__ = __webpack_require__("5Bu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Forms_Wizard_vue__ = __webpack_require__("eSiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Tables_RegularTables_vue__ = __webpack_require__("yg6A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Tables_ExtendedTables_vue__ = __webpack_require__("jJHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Tables_PaginatedTables_vue__ = __webpack_require__("Kakj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Maps_GoogleMaps_vue__ = __webpack_require__("Dwjx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Maps_FullScreenMap_vue__ = __webpack_require__("mj6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Maps_VectorMapsPage_vue__ = __webpack_require__("ZZNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Calendar_CalendarRoute_vue__ = __webpack_require__("KWr6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Charts_vue__ = __webpack_require__("uwQC");






































var componentsMenu = {
  path: '/components',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/components/buttons',
  children: [{
    path: 'buttons',
    name: 'Buttons',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Components_Buttons_vue__["a" /* default */]
  }, {
    path: 'grid-system',
    name: 'Grid System',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Components_GridSystem_vue__["a" /* default */]
  }, {
    path: 'panels',
    name: 'Panels',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Components_Panels_vue__["a" /* default */]
  }, {
    path: 'sweet-alert',
    name: 'Sweet Alert',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Components_SweetAlert_vue__["a" /* default */]
  }, {
    path: 'notifications',
    name: 'Notifications',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Components_Notifications_vue__["a" /* default */]
  }, {
    path: 'icons',
    name: 'Icons',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Components_Icons_vue__["a" /* default */]
  }, {
    path: 'typography',
    name: 'Typography',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Components_Typography_vue__["a" /* default */]
  }]
};
var formsMenu = {
  path: '/forms',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/forms/regular',
  children: [{
    path: 'regular',
    name: 'Regular Forms',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Forms_RegularForms_vue__["a" /* default */]
  }, {
    path: 'extended',
    name: 'Extended Forms',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Forms_ExtendedForms_vue__["a" /* default */]
  }, {
    path: 'validation',
    name: 'Validation Forms',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Forms_ValidationForms_vue__["a" /* default */]
  }, {
    path: 'wizard',
    name: 'Wizard',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Forms_Wizard_vue__["a" /* default */]
  }]
};

var tablesMenu = {
  path: '/table-list',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/table-list/regular',
  children: [{
    path: 'regular',
    name: 'Regular Tables',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Tables_RegularTables_vue__["a" /* default */]
  }, {
    path: 'extended',
    name: 'Extended Tables',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Tables_ExtendedTables_vue__["a" /* default */]
  }, {
    path: 'paginated',
    name: 'Paginated Tables',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Tables_PaginatedTables_vue__["a" /* default */]
  }]
};

var mapsMenu = {
  path: '/maps',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/maps/google',
  children: [{
    path: 'google',
    name: 'Google Maps',
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Maps_GoogleMaps_vue__["a" /* default */]
  }, {
    path: 'full-screen',
    name: 'Full Screen Map',
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Maps_FullScreenMap_vue__["a" /* default */]
  }, {
    path: 'vector-map',
    name: 'Vector Map',
    component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Maps_VectorMapsPage_vue__["a" /* default */]
  }]
};

var pagesMenu = {
  path: '/pages',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/pages/user',
  children: [{
    path: 'user',
    name: 'User Page',
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Pages_UserProfile_vue__["a" /* default */]
  }, {
    path: 'timeline',
    name: 'Timeline Page',
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Pages_TimeLinePage_vue__["a" /* default */]
  }]
};

var loginPage = {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */]
};

var registerPage = {
  path: '/register',
  name: 'Register',
  component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Pages_Register_vue__["a" /* default */]
};

var lockPage = {
  path: '/lock',
  name: 'Lock',
  component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Pages_Lock_vue__["a" /* default */]
};

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/overview',
  children: [{
    path: 'calendar',
    name: 'Calendar',
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Calendar_CalendarRoute_vue__["a" /* default */]
  }, {
    path: 'charts',
    name: 'Charts',
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Charts_vue__["a" /* default */]
  }]
}, componentsMenu, formsMenu, tablesMenu, mapsMenu, pagesMenu, loginPage, registerPage, lockPage, {
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/admin/overview',
  children: [{
    path: 'overview',
    name: 'Overview',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_Overview_vue__["a" /* default */]
  }, {
    path: 'stats',
    name: 'Stats',
    component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Dashboard_Stats_vue__["a" /* default */]
  }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("v2o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f88473_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("wR4F");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f88473_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TO8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((_vm.statsCards),function(stats){return _c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",class:("icon-" + (stats.type)),attrs:{"slot":"header"},slot:"header"},[_c('i',{class:stats.icon})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(stats.title))]),_vm._v("\n          "+_vm._s(stats.value)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('i',{class:stats.footerIcon}),_vm._v(" "+_vm._s(stats.footerText)+"\n        ")])])],1)}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('world-map')],1),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.earningsChart.data,"chart-options":_vm.earningsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("$34,657")]),_vm._v(" "),_c('span',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n            +18%\n          ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n            total earnings "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" ten "),_c('span',{staticClass:"text-muted"},[_vm._v("quarters")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n            Financial Statistics\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-plus"})])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":70,"title":"Dashboard","description":"Monthly sales target","color":"blue"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":34,"title":"Orders","description":"Completed","color":"green"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":62,"title":"New Visitors","description":"Out of total number","color":"orange"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":10,"title":"Subscriptions","description":"Monthly newsletter","color":"brown"}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Global Sales by Top Locations")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products that were shipped")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/US.png"}})])]),_vm._v(" "),_c('td',[_vm._v("USA")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        2.920\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        53.23%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/DE.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Germany")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        1.300\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        20.43%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/AU.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Australia")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        760\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        10.35%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/GB.png"}})])]),_vm._v(" "),_c('td',[_vm._v("United Kingdom")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        690\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        7.87%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/RO.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Romania")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        600\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        5.94%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/BR.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Brasil")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        550\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        4.34%\n                      ")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarSharePlugin_vue__ = __webpack_require__("9BoN");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */],
    SidebarShare: __WEBPACK_IMPORTED_MODULE_5__SidebarSharePlugin_vue__["a" /* default */]
  },
  data: function data() {
    return {
      sidebarBackground: 'black',
      sidebarTextColor: 'success'
    };
  },

  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "TqFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_social_sharing__ = __webpack_require__("VK1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_github_buttons__ = __webpack_require__("hEsw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_github_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_github_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_github_buttons_dist_vue_github_buttons_css__ = __webpack_require__("A4gK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_github_buttons_dist_vue_github_buttons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_github_buttons_dist_vue_github_buttons_css__);







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_social_sharing___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_github_buttons___default.a, { useCache: true });

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: {
      type: String,
      default: 'black'
    },
    textColor: {
      type: String,
      default: 'success'
    }
  },
  data: function data() {
    return {
      documentationLink: 'https://demos.creative-tim.com/bs3/vue-paper-dashboard-pro/documentation?selectedKind=Welcome&selectedStory=to%20Vue%20Paper%20Dashboard%20PRO&full=0&down=1&left=1&panelRight=0&downPanel=storybook%2Factions%2Factions-panel',
      shareUrl: 'https://www.creative-tim.com/product/vue-paper-dashboard-pro',
      buyUrl: 'https://www.creative-tim.com/product/vue-paper-dashboard-pro',
      freeUrl: 'https://www.creative-tim.com/product/vue-paper-dashboard',
      isOpen: false,
      sidebarColors: [{ color: 'white', active: false }, { color: 'black', active: true }, { color: 'brown', active: false }],
      sidebarTextColors: [{ color: 'primary', active: false }, { color: 'info', active: false }, { color: 'success', active: true }, { color: 'warning', active: false }, { color: 'danger', active: false }]
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    },
    toggleList: function toggleList(list, itemToActivate) {
      list.forEach(function (listItem) {
        listItem.active = false;
      });
      itemToActivate.active = true;
    },
    changeSidebarBackground: function changeSidebarBackground(item) {
      this.$emit('update:color', item.color);
      this.toggleList(this.sidebarColors, item);
    },
    changeSidebarLinkColor: function changeSidebarLinkColor(item) {
      this.$emit('update:textColor', item.color);
      this.toggleList(this.sidebarTextColors, item);
    }
  }
});

/***/ }),

/***/ "U6TR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__ = __webpack_require__("5NHr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__ = __webpack_require__("fYtj");
function injectStyle (ssrContext) {
  __webpack_require__("pZL1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UQPL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UTB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V+Sv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("wJKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag__ = __webpack_require__("orbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css__ = __webpack_require__("BxWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider__ = __webpack_require__("g2bL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");



















var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PProgress', __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      enabledRadio: '2',
      disabledRadio: '2',
      switches: {
        defaultOn: true,
        defaultOff: false,
        plainOn: true,
        plainOff: false,
        withIconsOn: true,
        withIconsOff: false
      },
      sliders: {
        simple: 30,
        rangeSlider: [20, 50]
      },
      selects: {
        simple: '',
        countries: [{ value: 'Bahasa Indonesia', label: 'Bahasa Indonesia' }, { value: 'Bahasa Melayu', label: 'Bahasa Melayu' }, { value: 'Català', label: 'Català' }, { value: 'Dansk', label: 'Dansk' }, { value: 'Deutsch', label: 'Deutsch' }, { value: 'English', label: 'English' }, { value: 'Español', label: 'Español' }, { value: 'Eλληνικά', label: 'Eλληνικά' }, { value: 'Français', label: 'Français' }, { value: 'Italiano', label: 'Italiano' }, { value: 'Magyar', label: 'Magyar' }, { value: 'Nederlands', label: 'Nederlands' }, { value: 'Norsk', label: 'Norsk' }, { value: 'Polski', label: 'Polski' }, { value: 'Português', label: 'Português' }, { value: 'Suomi', label: 'Suomi' }, { value: 'Svenska', label: 'Svenska' }, { value: 'Türkçe', label: 'Türkçe' }, { value: 'Íslenska', label: 'Íslenska' }, { value: 'Čeština', label: 'Čeština' }, { value: 'Русский', label: 'Русский' }, { value: 'ภาษาไทย', label: 'ภาษาไทย' }, { value: '中文 (简体)', label: '中文 (简体)' }, { value: 'W">中文 (繁體)', label: 'W">中文 (繁體)' }, { value: '日本語', label: '日本語' }, { value: '한국어', label: '한국어' }],
        multiple: 'ARS'
      },
      tags: {
        dynamicTags: ['Tag 1', 'Tag 2', 'Tag 3'],
        inputVisible: false,
        inputValue: ''
      },
      pickerOptions1: {
        shortcuts: [{
          text: 'Today',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Yesterday',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'A week ago',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      datePicker: '',
      dateTimePicker: '',
      timePicker: ''
    };
  },

  methods: {
    handleClose: function handleClose(tag) {
      this.tags.dynamicTags.splice(this.tags.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.tags.inputVisible = true;
      this.$nextTick(function () {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = '';
    }
  }
});

/***/ }),

/***/ "V5Z/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V67u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",class:_vm.switchClass},[_c('div',{staticClass:"bootstrap-switch-container",on:{"click":function($event){_vm.triggerToggle()}}},[_c('span',{staticClass:"bootstrap-switch-handle-on ",class:("bootstrap-switch-" + _vm.type)},[_vm._t("on",[_vm._v("\n          "+_vm._s(_vm.onText)+"\n      ")])],2),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-label"}),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-handle-off bootstrap-switch-default"},[_vm._t("off",[_vm._v("\n          "+_vm._s(_vm.offText)+"\n      ")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VEgf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VziK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-5"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-7"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WFzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__ = __webpack_require__("x/a9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca0e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__ = __webpack_require__("qAvE");
function injectStyle (ssrContext) {
  __webpack_require__("PGBT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca0e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WI53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("hJZU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36bdcb35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("xl+f");
function injectStyle (ssrContext) {
  __webpack_require__("vtiC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36bdcb35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wdwa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ws9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Salary","property":"salary"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-plain"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Salary","property":"salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{attrs:{"row-class-name":_vm.tableRowClassName,"data":_vm.tableData}},[_c('el-table-column',{staticClass:"success",attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{staticClass:"danger",attrs:{"label":"Salary","property":"salary"}}),_vm._v(" "),_c('el-table-column',{staticClass:"info",attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}})],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Striped table")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Table on Plain Background")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Regular Table with Colors")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XIFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XPMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XXU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  data: function data() {
    return {
      isClosed: true
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    }
  }
});

/***/ }),

/***/ "XaJ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YNHp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YcmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YvUw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z450":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-progress',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    value: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("UTB8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZZNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VectorMapsPage_vue__ = __webpack_require__("GdNa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d65b76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VectorMapsPage_vue__ = __webpack_require__("RUAa");
function injectStyle (ssrContext) {
  __webpack_require__("5uDj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VectorMapsPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d65b76_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VectorMapsPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZzaD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a8eF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      defaultPagination: 3,
      infoPagination: 5
    };
  }
});

/***/ }),

/***/ "aCDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "alEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.confirmPassword),expression:"modelValidations.confirmPassword"},{name:"model",rawName:"v-model",value:(_vm.model.confirmPassword),expression:"model.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","name":"confirm"},domProps:{"value":(_vm.model.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirm.invalid),expression:"confirm.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('confirm'))+"\n        ")])]),_vm._v(" "),_c('p-checkbox',[_vm._v("Subscribe to newsletter")])],1),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Register")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Register Form\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "atjs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");



var Calendar = function Calendar() {
  return {
    component: __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "dYRv")),
    loading: __WEBPACK_IMPORTED_MODULE_0_src_components_Dashboard_Layout_LoadingMainPanel_vue__["a" /* default */],
    delay: 100
  };
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Calendar: Calendar
  }
});

/***/ }),

/***/ "bAsJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bJ0t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'password'])),
  data: function data() {
    return {
      model: {
        email: '',
        password: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "bTbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0012b22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("9nxM");
function injectStyle (ssrContext) {
  __webpack_require__("idYH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0012b22c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bx0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Task_vue__ = __webpack_require__("fm0D");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Task: __WEBPACK_IMPORTED_MODULE_1__Task_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tasks: [{
        title: 'Sign contract for "What are conference organizers afraid of?"'
      }, {
        title: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
      }, {
        title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
      }, {
        title: 'Create 4 Invisible User Experiences you Never Knew About'
      }, {
        title: 'Read "Following makes Medium better"'
      }, {
        title: 'Unfollow 5 enemies from twitter'
      }]
    };
  },

  methods: {
    handleTaskEdit: function handleTaskEdit(index) {
      alert('You want to edit task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    },
    handleTaskDelete: function handleTaskDelete(index) {
      alert('You want to delete task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    }
  }
});

/***/ }),

/***/ "bxZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calendar')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8qD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("XIFX");
function injectStyle (ssrContext) {
  __webpack_require__("YNHp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "duHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lock_vue__ = __webpack_require__("RXFM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lock_vue__ = __webpack_require__("qQLU");
function injectStyle (ssrContext) {
  __webpack_require__("Mi7u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc277c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("C38E");
function injectStyle (ssrContext) {
  __webpack_require__("SKQV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc277c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eFVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eSiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__ = __webpack_require__("gww+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf9cce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__ = __webpack_require__("3KWc");
function injectStyle (ssrContext) {
  __webpack_require__("6bl1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf9cce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "euVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f4B7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f6/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__ = __webpack_require__("0Bz4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef322ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__ = __webpack_require__("+mNl");
function injectStyle (ssrContext) {
  __webpack_require__("LRfs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef322ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fP9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__ = __webpack_require__("a8eF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e8c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__ = __webpack_require__("BYD1");
function injectStyle (ssrContext) {
  __webpack_require__("bTbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e8c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fPpX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fYtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._t("badge",[_c('div',{staticClass:"timeline-badge",class:_vm.badgeType},[_c('i',{class:_vm.badgeIcon})])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel"},[_c('div',{staticClass:"timeline-heading"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"timeline-body"},[_vm._t("body")],2),_vm._v(" "),_c('h6',[_vm._t("footer")],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fm0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__("iGuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__("CRWE");
function injectStyle (ssrContext) {
  __webpack_require__("IWrx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gBnQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gKTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gP6t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gww+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__ = __webpack_require__("jPKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__ = __webpack_require__("oE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"],
    FirstStep: __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__["a" /* default */],
    SecondStep: __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__["a" /* default */]
  },
  methods: {
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.firstStep.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('Good job!', 'You clicked the finish button!', 'success');
    }
  }
});

/***/ }),

/***/ "hASK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-switch',
  props: {
    label: String,
    value: [Array, Boolean],
    disabled: [Boolean, String],
    onText: String,
    offText: String,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      return base + state;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
});

/***/ }),

/***/ "hJZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "hzu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"job","label":"Job Position"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"Salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-info btn-xs btn-icon like",on:{"click":function($event){_vm.handleLike(props.$index, props.row)}}},[_c('i',{staticClass:"ti-heart"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-warning btn-xs btn-icon edit",on:{"click":function($event){_vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-danger btn-xs btn-icon remove",on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row table-full-width"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"job","label":"Job Position"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"Salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-shopping",staticStyle:{"width":"100%"},attrs:{"summary-method":_vm.getSummaries,"show-summary":"","data":_vm.productsTable}},[_c('el-table-column',{attrs:{"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":props.row.image,"alt":"Agenda"}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.row.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(props.row.subTitle))])]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-price",attrs:{"min-width":"80","label":"Price"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('small',[_vm._v("€")]),_vm._v(" "+_vm._s(props.row.price)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"150","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.quantity)+"\n                "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){props.row.quantity > 0 ? props.row.quantity-- : 0}}},[_c('i',{staticClass:"ti-minus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){props.row.quantity++}}},[_c('i',{staticClass:"ti-plus"})])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Total","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_c('small',[_vm._v("€")]),_vm._v(" "+_vm._s(props.row.quantity * props.row.price)+" ")])]}}])})],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table with Links")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table with Switches")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("With some subtitle")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table Big Boy")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("A table for content management")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i/rH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"row",attrs:{"id":"loading"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i0bx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panels_vue__ = __webpack_require__("sTXs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb51baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panels_vue__ = __webpack_require__("Hyh/");
function injectStyle (ssrContext) {
  __webpack_require__("M0iJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb51baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iGuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    task: {
      type: Object,
      default: function _default() {
        return {
          title: ''
        };
      }
    },
    index: Number
  },
  methods: {
    handleEditClick: function handleEditClick() {
      this.$emit('on-edit', this.index);
    },
    handleDeleteClick: function handleDeleteClick() {
      this.$emit('on-delete', this.index);
    }
  }
});

/***/ }),

/***/ "iXuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");






var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "idYH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ifSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("XXU8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d358ae3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("0Krs");
function injectStyle (ssrContext) {
  __webpack_require__("JW7q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d358ae3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jJHM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedTables_vue__ = __webpack_require__("PzXG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d99d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedTables_vue__ = __webpack_require__("hzu0");
function injectStyle (ssrContext) {
  __webpack_require__("LQk8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d99d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jPKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__ = __webpack_require__("Rrpr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea89db28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__ = __webpack_require__("uOOa");
function injectStyle (ssrContext) {
  __webpack_require__("UQPL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea89db28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jcvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      details: [{
        title: '12',
        subTitle: 'Files'
      }, {
        title: '2GB',
        subTitle: 'Used'
      }, {
        title: '24,6$',
        subTitle: 'Spent'
      }]
    };
  },

  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-md-3 col-md-offset-1';
      } else if (remainder === 2) {
        return 'col-md-4';
      } else {
        return 'col-md-3';
      }
    }
  }
});

/***/ }),

/***/ "k8VF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__ = __webpack_require__("HHnu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__ = __webpack_require__("A+TP");
function injectStyle (ssrContext) {
  __webpack_require__("qAgR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kCrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"http://www.creative-tim.com"}},[_vm._v("\n            Creative Tim\n          ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://blog.creative-tim.com"}},[_vm._v("\n            Blog\n          ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://www.creative-tim.com/license"}},[_vm._v("\n            Licenses\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"copyright pull-right"},[_vm._v("\n      © Coded with\n      "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n      "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Cristi Jora")]),_vm._v(".\n      "),_c('span',[_vm._v("Designed by "),_c('a',{attrs:{"href":"https://www.creative-tim.com/?ref=pdf-vuejs","target":"_blank"}},[_vm._v("Creative Tim")]),_vm._v(".")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("+2Xc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lS3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',{staticClass:"form-horizontal"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Required text")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.requiredText),expression:"modelValidations.requiredText"},{name:"model",rawName:"v-model",value:(_vm.model.requiredText),expression:"model.requiredText"}],staticClass:"form-control",attrs:{"type":"text","name":"requiredText"},domProps:{"value":(_vm.model.requiredText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "requiredText", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.requiredText.invalid),expression:"requiredText.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('requiredText'))+"\n            ")])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('email'))+"\n            ")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.number),expression:"modelValidations.number"},{name:"model",rawName:"v-model",value:(_vm.model.number),expression:"model.number"}],staticClass:"form-control",attrs:{"type":"number","name":"number"},domProps:{"value":(_vm.model.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "number", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.number.invalid),expression:"number.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('number'))+"\n            ")])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Url")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.url),expression:"modelValidations.url"},{name:"model",rawName:"v-model",value:(_vm.model.url),expression:"model.url"}],staticClass:"form-control",attrs:{"type":"url","name":"url"},domProps:{"value":(_vm.model.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "url", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.url.invalid),expression:"url.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('url'))+"\n            ")])]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group column-sizing"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("\n            Equal to\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.idSource),expression:"modelValidations.idSource"},{name:"model",rawName:"v-model",value:(_vm.model.idSource),expression:"model.idSource"}],staticClass:"form-control",attrs:{"name":"idSource","placeholder":"#idSource","type":"text"},domProps:{"value":(_vm.model.idSource)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "idSource", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.idSource.invalid),expression:"idSource.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('idSource'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.idDestination),expression:"modelValidations.idDestination"},{name:"model",rawName:"v-model",value:(_vm.model.idDestination),expression:"model.idDestination"}],staticClass:"form-control",attrs:{"name":"idDestination","placeholder":"#idDestination","type":"text"},domProps:{"value":(_vm.model.idDestination)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "idDestination", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.idDestination.invalid),expression:"idDestination.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('idDestination'))+"\n            ")])]),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Validate inputs")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Register Form\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("required:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("email:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("decimal:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("url:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("confirmed : 'idSource'")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "me3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("hASK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aef443c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("V67u");
function injectStyle (ssrContext) {
  __webpack_require__("J0Sr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aef443c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mj6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullScreenMap_vue__ = __webpack_require__("SUPC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3bbf9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullScreenMap_vue__ = __webpack_require__("z48K");
function injectStyle (ssrContext) {
  __webpack_require__("ryiV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullScreenMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3bbf9a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FullScreenMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mmP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      $Chartist: null
    };
  },

  methods: {
    initPerformanceChart: function initPerformanceChart() {
      var dataPerformance = {
        labels: ['6pm', '9pm', '11pm', '2am', '4am', '8am', '2pm', '5pm', '8pm', '11pm', '4am'],
        series: [[1, 6, 8, 7, 4, 7, 8, 12, 16, 17, 14, 13]]
      };

      var optionsPerformance = {
        showPoint: false,
        lineSmooth: true,
        axisX: {
          showGrid: false,
          showLabel: true
        },
        axisY: {
          offset: 40

        },
        low: 0,
        high: 16,
        height: '250px'
      };

      this.$Chartist.Line('#chartPerformance', dataPerformance, optionsPerformance);
    },
    initActivityChart: function initActivityChart() {
      var data = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895], [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]]
      };

      var options = {
        seriesBarDistance: 10,
        axisX: {
          showGrid: false
        },
        height: '250px'
      };

      var responsiveOptions = [['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return value[0];
          }
        }
      }]];

      this.$Chartist.Bar('#chartActivity', data, options, responsiveOptions);
    },
    initStockChart: function initStockChart() {
      var dataStock = {
        labels: ['\'07', '\'08', '\'09', '\'10', '\'11', '\'12', '\'13', '\'14', '\'15'],
        series: [[22.20, 34.90, 42.28, 51.93, 62.21, 80.23, 62.21, 82.12, 102.50, 107.23]]
      };
      var optionsStock = {
        lineSmooth: false,
        axisY: {
          offset: 40,
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return '$' + value;
          }
        },
        low: 10,
        height: '250px',
        high: 110,
        classNames: {
          point: 'ct-point ct-green',
          line: 'ct-line ct-green'
        }
      };
      this.$Chartist.Line('#chartStock', dataStock, optionsStock);
    },
    initViewsChart: function initViewsChart() {
      var dataViews = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
      };
      var optionsViews = {
        seriesBarDistance: 10,
        classNames: {
          bar: 'ct-bar'
        },
        axisX: {
          showGrid: false
        },
        height: '250px'
      };
      var responsiveOptionsViews = [['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function labelInterpolationFnc(value) {
            return value[0];
          }
        }
      }]];
      this.$Chartist.Bar('#chartViews', dataViews, optionsViews, responsiveOptionsViews);
    },
    initCharts: function initCharts() {
      this.initPerformanceChart();
      this.initStockChart();
      this.initViewsChart();
      this.initActivityChart();
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "715g"));

            case 2:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initCharts();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "negu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Team members',
      members: [{
        image: 'static/img/faces/face-0.jpg',
        name: 'Dj Khaled',
        status: 'Offline'
      }, {
        image: 'static/img/faces/face-1.jpg',
        name: 'Creative Tim',
        status: 'Available'
      }, {
        image: 'static/img/faces/face-3.jpg',
        name: 'Flume',
        status: 'Busy'
      }]
    };
  },

  methods: {
    getStatusClass: function getStatusClass(status) {
      switch (status) {
        case 'Offline':
          return 'text-muted';
        case 'Available':
          return 'text-success';
        case 'Busy':
          return 'text-danger';
        default:
          return 'text-success';
      }
    }
  }
});

/***/ }),

/***/ "oE/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__ = __webpack_require__("qeuK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc7402e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__ = __webpack_require__("Nrso");
function injectStyle (ssrContext) {
  __webpack_require__("f4B7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc7402e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oHle":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pPMM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pZL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pa/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__ = __webpack_require__("bx0x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__ = __webpack_require__("whIq");
function injectStyle (ssrContext) {
  __webpack_require__("YcmF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pfXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      radios: {
        radio1: '1',
        radio2: '2',
        radio3: '2'
      },
      checkboxes: {
        first: false,
        second: false,
        a: false,
        b: false,
        c: false,
        unchecked: false,
        checked: true,
        disabledUnchecked: false,
        disabledChecked: true
      }
    };
  }
});

/***/ }),

/***/ "psw9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qAgR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qAvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-circle-chart",attrs:{"data-background-color":_vm.color}},[_c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v(_vm._s(_vm.percentage)+"%")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qQLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/admin"}},[_vm._v("Paper Dashboard PRO")])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n          Dashboard\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page lock-page",staticStyle:{"background-image":"url('static/img/background/background-5.png')"},attrs:{"data-color":"green","data-image":"static/img/background/background-5.png"}},[_c('div',{staticClass:"content"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-lock"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar",attrs:{"src":"static/img/faces/face-2.jpg","alt":"..."}})]),_vm._v(" "),_c('h4',[_vm._v("Chet Faker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Enter Password"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd",attrs:{"type":"button"}},[_vm._v("Unlock")])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Cristi Jora")]),_vm._v(".\n            Designed by "),_c('a',{attrs:{"href":"https://www.creative-tim.com/?ref=pdf-vuejs","target":"_blank"}},[_vm._v("Creative Tim")]),_vm._v(".\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qeuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['website', 'language', 'bootstrapVersion'])),
  data: function data() {
    return {
      model: {
        website: '',
        frameworkType: '',
        language: '',
        bootstrapVersion: '',
        price: ''
      },
      modelValidations: {
        website: {
          url: true,
          required: true
        },
        language: {
          required: true
        },
        bootstrapVersion: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "qjBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("24 Hours Performance")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Line Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartPerformance"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("NASDAQ: AAPL")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Line Chart with Points")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartStock"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Views")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bar Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartViews"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Activity")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Multiple Bars Chart")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"ct-chart",attrs:{"id":"chartActivity"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r2+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('form',{attrs:{"method":"#","action":"#"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p-checkbox',[_vm._v("Subscribe to newsletter")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"}},[_vm._v("Submit")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('form',{staticClass:"form-horizontal"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3"}),_vm._v(" "),_c('p-checkbox',{staticClass:"col-md-9"},[_vm._v("Remember me")])],1)]),_vm._v(" "),_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"}},[_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Checkboxes and radios")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.checkboxes.first),callback:function ($$v) {_vm.$set(_vm.checkboxes, "first", $$v)},expression:"checkboxes.first"}},[_vm._v("First checkbox")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.checkboxes.second),callback:function ($$v) {_vm.$set(_vm.checkboxes, "second", $$v)},expression:"checkboxes.second"}},[_vm._v("Second checkbox")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.radios.radio1),callback:function ($$v) {_vm.$set(_vm.radios, "radio1", $$v)},expression:"radios.radio1"}},[_vm._v("First Radio")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.radios.radio1),callback:function ($$v) {_vm.$set(_vm.radios, "radio1", $$v)},expression:"radios.radio1"}},[_vm._v("Second Radio")])],1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Inline checkboxes")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.a),callback:function ($$v) {_vm.$set(_vm.checkboxes, "a", $$v)},expression:"checkboxes.a"}},[_vm._v("a")]),_vm._v(" "),_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.b),callback:function ($$v) {_vm.$set(_vm.checkboxes, "b", $$v)},expression:"checkboxes.b"}},[_vm._v("b")]),_vm._v(" "),_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.c),callback:function ($$v) {_vm.$set(_vm.checkboxes, "c", $$v)},expression:"checkboxes.c"}},[_vm._v("c")])],1)])]),_vm._v(" "),_c('fieldset',[_c('legend',[_vm._v("Input Variants")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Custom Checkboxes & radios")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-sm-offset-1"},[_c('p-checkbox',{model:{value:(_vm.checkboxes.unchecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "unchecked", $$v)},expression:"checkboxes.unchecked"}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.checkboxes.checked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "checked", $$v)},expression:"checkboxes.checked"}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":true},model:{value:(_vm.checkboxes.disabledUnchecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "disabledUnchecked", $$v)},expression:"checkboxes.disabledUnchecked"}},[_vm._v("Disabled unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":true},model:{value:(_vm.checkboxes.disabledChecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "disabledChecked", $$v)},expression:"checkboxes.disabledChecked"}},[_vm._v("Disabled checked")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Radio is on")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1","disabled":true},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Disabled radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2","disabled":true},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Disabled radio is on")])],1)])]),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Stacked Form\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter email"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Horizontal Form\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Email"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"}},[_vm._v("\n                Sign in\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Form Elements")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("With help")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("A block of help text that breaks onto a new line.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","name":"password"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Placeholder")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"placeholder"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Disabled")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Disabled input here...","disabled":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Static control")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p',{staticClass:"form-control-static"},[_vm._v("hello@creative-tim.com")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group has-success"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input with success")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"Success"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group has-error"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input with error")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"Error"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group column-sizing"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Column sizing")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-3"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-4"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-5"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input groups")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("@")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Username"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(".00")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(".00")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Textarea")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"Here can be your nice text","rows":"3"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rP9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__ = __webpack_require__("9597");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__ = __webpack_require__("v98p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserProfile_MembersCard_vue__ = __webpack_require__("4qt1");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditProfileForm: __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__["a" /* default */],
    UserCard: __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__["a" /* default */],
    MembersCard: __WEBPACK_IMPORTED_MODULE_2__UserProfile_MembersCard_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "ribu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SweetAlert_vue__ = __webpack_require__("/ZBZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76315f86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SweetAlert_vue__ = __webpack_require__("H2oj");
function injectStyle (ssrContext) {
  __webpack_require__("d8qD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SweetAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76315f86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SweetAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ryiV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sMOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("wfBj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f9ae83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("8HRS");
function injectStyle (ssrContext) {
  __webpack_require__("gBnQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f9ae83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "sTXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__);











__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeName: 'first'
    };
  }
});

/***/ }),

/***/ "sbDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__ = __webpack_require__("Z450");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b77cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__ = __webpack_require__("+WI1");
function injectStyle (ssrContext) {
  __webpack_require__("gP6t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b77cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sk1x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "swfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("320+ Themify Icons")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Handcrafted by our friends from\n          "),_c('a',{attrs:{"target":"_blank","href":"https://themify.me/"}},[_vm._v("Themify")]),_vm._v(".")])]),_vm._v(" "),_c('div',{staticClass:"card-content all-icons"},[_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Arrows & Direction Icons ")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-vertical"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-vertical")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-horizontal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-horizontal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-move"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-move")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-fullscreen"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-fullscreen")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-top-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-top-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-top-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-top-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-corner"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-corner")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-v-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-v-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-h"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-h")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-back-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-back-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-back-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-back-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-exchange-vertical"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-exchange-vertical")])])]),_vm._v(" "),_c('h3',[_vm._v("Web App Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wand"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wand")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-save"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-save")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-save-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-save-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-direction"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-direction")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-direction-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-direction-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-user"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-user")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-link"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-link")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-unlink"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-unlink")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-trash"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-trash")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-target"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-target")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-desktop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-desktop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tablet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tablet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mobile"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mobile")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-email"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-email")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-star"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-star")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-spray"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-spray")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-signal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-signal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shopping-cart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shopping-cart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shopping-cart-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shopping-cart-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-settings")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-search"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-search")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zoom-in"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zoom-in")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zoom-out"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zoom-out")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cut"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cut")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-pencil"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-pencil")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bookmark"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bookmark")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bookmark-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bookmark-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-reload"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-reload")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-plus"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-plus")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-minus"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-minus")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-close"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-close")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paint-roller"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paint-roller")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paint-bucket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paint-bucket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-na"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-na")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-medall"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-medall")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-medall-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-medall-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-marker"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-marker")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-marker-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-marker-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-lock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-lock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-unlock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-unlock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-location-arrow"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-location-arrow")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layers"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layers")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layers-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layers-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-key"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-key")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-image"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-image")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-heart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-heart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-heart-broken"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-heart-broken")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-stop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-stop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-open"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-open")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-drag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-drag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-eye"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-eye")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-import"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-import")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-export"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-export")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cup"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cup")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-crown"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-crown")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comments"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comments")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comment"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comment")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comment-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comment-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thought"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thought")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-clip"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-clip")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-check"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-check")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-check-box"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-check-box")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-camera"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-camera")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-announcement"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-announcement")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-brush"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-brush")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-brush-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-brush-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-palette"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-palette")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-briefcase"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-briefcase")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bolt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bolt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bolt-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bolt-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-blackboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-blackboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-world"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-world")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wheelchair"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wheelchair")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-car"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-car")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-truck"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-truck")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-timer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-timer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ticket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ticket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thumb-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thumb-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thumb-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thumb-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stats-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stats-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stats-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stats-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shine"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shine")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-right-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-right-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-left-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-left-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shield"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shield")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-notepad"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-notepad")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-server"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-server")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pulse"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pulse")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-printer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-printer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-power-off"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-power-off")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-plug"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-plug")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pie-chart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pie-chart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-panel"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-panel")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-package"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-package")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-music"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-music")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-music-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-music-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mouse"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mouse")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mouse-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mouse-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-money"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-money")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microphone"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microphone")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-menu"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-menu")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-menu-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-menu-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-map"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-map")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-map-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-map-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-location-pin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-location-pin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-light-bulb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-light-bulb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-info"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-info")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-infinite"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-infinite")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-id-badge"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-id-badge")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hummer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hummer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-home"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-home")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-help"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-help")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-headphone"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-headphone")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-harddrives"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-harddrives")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-harddrive"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-harddrive")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-gift"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-gift")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-game"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-game")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-filter"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-filter")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-files"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-files")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-file"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-file")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zip"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zip")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-folder"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-folder")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-envelope"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-envelope")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dashboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dashboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-clipboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-clipboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-calendar"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-calendar")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-book"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-book")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bell")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-basketball"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-basketball")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bar-chart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bar-chart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bar-chart-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bar-chart-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-archive"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-archive")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-anchor"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-anchor")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-alert"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-alert")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-alarm-clock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-alarm-clock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-agenda"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-agenda")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-write"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-write")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wallet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wallet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-video-clapper"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-video-clapper")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-video-camera"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-video-camera")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vector"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vector")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-support"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-support")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stamp"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stamp")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-slice"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-slice")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shortcode"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shortcode")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-receipt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-receipt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil-alt2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil-alt2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-eraser"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-eraser")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-more"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-more")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-more-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-more-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microphone-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microphone-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-magnet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-magnet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-double"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-double")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-dotted"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-dotted")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-dashed"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-dashed")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ink-pen"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ink-pen")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-info-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-info-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-help-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-help-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-headphone-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-headphone-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-gallery"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-gallery")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-face-smile"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-face-smile")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-face-sad"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-face-sad")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-credit-card"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-credit-card")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comments-smiley"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comments-smiley")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-time"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-time")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-share"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-share")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-share-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-share-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rocket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rocket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-new-window"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-new-window")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rss"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rss")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rss-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rss-alt")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Control Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-stop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-stop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-shuffle"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-shuffle")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-play"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-play")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-pause"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-pause")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-forward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-forward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-backward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-backward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-volume"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-volume")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-skip-forward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-skip-forward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-skip-backward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-skip-backward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-record"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-record")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-eject"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-eject")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Text Editor")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paragraph"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paragraph")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-uppercase"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-uppercase")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-underline"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-underline")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-text"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-text")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-Italic"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-Italic")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-smallcap"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-smallcap")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-list-ol"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-list-ol")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-justify"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-justify")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-quote-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-quote-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-quote-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-quote-left")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Layout Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-default"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-default")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-default-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-default-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-window"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-window")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-min"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-min")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-slider"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-slider")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-slider-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-slider-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-none"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-none")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-placeholder"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-placeholder")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-separated"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-separated")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-right-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-right-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-left-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-left-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-center-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-center-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-thumb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-thumb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-thumb-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-thumb-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-post"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-post")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-large-image"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-large-image")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-line-solid"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-line-solid")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid4"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid4")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2-thumb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2-thumb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-btn-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-btn-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-btn-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-btn-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column4"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column4")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-separated"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-separated")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-merged"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-merged")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widgetized"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widgetized")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widget"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widget")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widget-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widget-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-list-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-list-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-grid"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-grid")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-upload"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-upload")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-download"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-download")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-loop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-loop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid4-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid4-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid3-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid3-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column4-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column4-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column3-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column3-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column2-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column2-alt")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Brand Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flickr"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flickr")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flickr-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flickr-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-instagram"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-instagram")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-google"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-google")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-github"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-github")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-facebook"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-facebook")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dropbox"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dropbox")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dropbox-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dropbox-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dribbble"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dribbble")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-apple"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-apple")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-android"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-android")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-yahoo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-yahoo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-trello"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-trello")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stack-overflow"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stack-overflow")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-soundcloud"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-soundcloud")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-sharethis"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-sharethis")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-sharethis-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-sharethis-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-reddit"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-reddit")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microsoft"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microsoft")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microsoft-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microsoft-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-linux"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-linux")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-jsfiddle"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-jsfiddle")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-joomla"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-joomla")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-html5"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-html5")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-css3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-css3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-drupal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-drupal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wordpress"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wordpress")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tumblr"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tumblr")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tumblr-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tumblr-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-skype"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-skype")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-youtube"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-youtube")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vimeo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vimeo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vimeo-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vimeo-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-twitter"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-twitter")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-twitter-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-twitter-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-linkedin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-linkedin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pinterest"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pinterest")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pinterest-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pinterest-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-logo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-logo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-favicon"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-favicon")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-favicon-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-favicon-alt")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tlmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'password', 'confirm'])),
  data: function data() {
    return {
      model: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        },
        confirmPassword: {
          required: true,
          confirmed: 'password'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "u9kn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uFAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("1V4J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d07bd1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("TO8p");
function injectStyle (ssrContext) {
  __webpack_require__("fPpX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d07bd1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uOOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please tell us more about yourself.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          First Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"},{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"ex: Mike"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('firstName'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Last Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"},{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"ex: Andrew"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('lastName'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Email\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uwQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charts_vue__ = __webpack_require__("mmP5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1719a15b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Charts_vue__ = __webpack_require__("qjBI");
function injectStyle (ssrContext) {
  __webpack_require__("BItS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Charts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1719a15b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v2o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "v71F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"Company","disabled":true,"placeholder":"Paper dashboard"},model:{value:(_vm.user.company),callback:function ($$v) {_vm.$set(_vm.user, "company", $$v)},expression:"user.company"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Username","placeholder":"Username"},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"email","label":"Username","placeholder":"Email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"First Name","placeholder":"First Name"},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Last Name","placeholder":"Last Name"},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Address","placeholder":"Home Address"},model:{value:(_vm.user.address),callback:function ($$v) {_vm.$set(_vm.user, "address", $$v)},expression:"user.address"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"City","placeholder":"City"},model:{value:(_vm.user.city),callback:function ($$v) {_vm.$set(_vm.user, "city", $$v)},expression:"user.city"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Country","placeholder":"Country"},model:{value:(_vm.user.country),callback:function ($$v) {_vm.$set(_vm.user, "country", $$v)},expression:"user.country"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","label":"Postal Code","placeholder":"ZIP Code"},model:{value:(_vm.user.postalCode),callback:function ($$v) {_vm.$set(_vm.user, "postalCode", $$v)},expression:"user.postalCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("About Me")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.aboutMe),expression:"user.aboutMe"}],staticClass:"form-control border-input",attrs:{"rows":"5","placeholder":"Here can be your description"},domProps:{"value":(_vm.user.aboutMe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "aboutMe", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.updateProfile($event)}}},[_vm._v("\n          Update Profile\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Edit Profile")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v98p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__("jcvC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3657aad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__("FQVD");
function injectStyle (ssrContext) {
  __webpack_require__("oHle")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3657aad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vIES":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0331ce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("VziK");
function injectStyle (ssrContext) {
  __webpack_require__("euVw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0331ce2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0331ce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vtiC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("GJqE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wJKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wR4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){_vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wfBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "whIq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-full-width table-tasks"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.tasks),function(task,index){return _c('task',{key:task.title,attrs:{"task":task,"index":index},on:{"on-edit":_vm.handleTaskEdit,"on-delete":_vm.handleTaskDelete}})}),1)])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tasks")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Backend development")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x/a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'circle-chart-card',
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    percentage: {
      type: Number,
      default: 0
    },
    title: String,
    description: String
  },
  data: function data() {
    return {
      chartId: 'no-id',
      chart: null
    };
  },

  methods: {
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 6,
        size: 160,
        scaleColor: false,
        trackColor: 'rgba(255,255,255,.25)',
        barColor: '#FFFFFF',
        animate: { duration: 2000, enabled: true }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var EasyPieChart;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "PeU/"));

            case 3:
              EasyPieChart = _context.sent;

              _this.renderChart(EasyPieChart);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    percentage: function percentage(newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

__webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "x36W"));
__webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "p4sG"));
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "xMeF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],staticClass:"fixed-plugin"},[_c('div',{staticClass:"dropdown show-dropdown",class:{open: _vm.isOpen}},[_c('a',{attrs:{"data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-cog fa-2x",on:{"click":_vm.toggleDropDown}})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"header-title"},[_vm._v("Sidebar Background")]),_vm._v(" "),_c('li',{staticClass:"adjustments-line text-center"},[_c('a',{staticClass:"switch-trigger background-color"},_vm._l((_vm.sidebarColors),function(item){return _c('span',{staticClass:"badge filter",class:[("badge-" + (item.color)),{active:item.active}],attrs:{"data-color":item.color},on:{"click":function($event){_vm.changeSidebarBackground(item)}}})}),0)]),_vm._v(" "),_c('li',{staticClass:"header-title"},[_vm._v("Sidebar Active Color")]),_vm._v(" "),_c('li',{staticClass:"adjustments-line text-center"},[_c('a',{staticClass:"switch-trigger active-color"},_vm._l((_vm.sidebarTextColors),function(item){return _c('span',{staticClass:"badge filter",class:[("badge-" + (item.color)),{active:item.active}],attrs:{"data-color":item.color},on:{"click":function($event){_vm.changeSidebarLinkColor(item)}}})}),0)]),_vm._v(" "),_c('li',{staticClass:"button-container"},[_c('div',{},[_c('a',{staticClass:"btn btn-info btn-block btn-fill",attrs:{"href":_vm.freeUrl,"target":"_blank"}},[_vm._v("Get Free Demo")])])]),_vm._v(" "),_c('li',{staticClass:"button-container"},[_c('div',{},[_c('a',{staticClass:"btn btn-danger btn-block btn-fill",attrs:{"href":_vm.buyUrl,"target":"_blank"}},[_vm._v("Buy for $49")])])]),_vm._v(" "),_c('li',{staticClass:"button-container"},[_c('div',{},[_c('a',{staticClass:"btn btn-default btn-block",attrs:{"href":_vm.documentationLink,"target":"_blank"}},[_vm._v("Documentation")])])]),_vm._v(" "),_c('li',{staticClass:"header-title"},[_vm._v("Thank you for sharing!")]),_vm._v(" "),_c('li',{staticClass:"button-container"},[_c('social-sharing',{attrs:{"url":_vm.shareUrl,"title":"Vue Paper Dashboard PRO - Premium Bootstrap Admin Template for Vue.js","hashtags":"vuejs, dashboard, bootstrap","twitter-user":"creativetim"},inlineTemplate:{render:function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('network',{staticClass:"btn btn-facebook btn-icon",attrs:{"network":"facebook"}},[_c('i',{staticClass:"fa fa-fw fa-facebook"})]),_vm._v(" "),_c('network',{staticClass:"btn btn-pinterest btn-icon",attrs:{"network":"pinterest"}},[_c('i',{staticClass:"fa fa-fw fa-pinterest"})]),_vm._v(" "),_c('network',{staticClass:"btn btn-twitter btn-icon",attrs:{"network":"twitter"}},[_c('i',{staticClass:"fa fa-fw fa-twitter"})])],1)},staticRenderFns:[]}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xl+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/admin"}},[_vm._v("Paper Dashboard PRO")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page",attrs:{"data-color":"","data-image":"static/img/background/background-2.jpg"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-wd ",attrs:{"type":"submit"}},[_vm._v("Let's go")]),_vm._v(" "),_c('div',{staticClass:"forgot"},[_c('router-link',{attrs:{"to":"/register"}},[_vm._v("\n                        Forgot your password?\n                      ")])],1)])])])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"full-page-background",staticStyle:{"background-image":"url(static/img/background/background-2.jpg)"}})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Login")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{staticClass:"form-control input-no-border",attrs:{"type":"email","placeholder":"Enter email"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{staticClass:"form-control input-no-border",attrs:{"type":"password","placeholder":"Password"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Cristi Jora")]),_vm._v(".\n            Designed by "),_c('a',{attrs:{"href":"https://www.creative-tim.com/?ref=pdf-vuejs","target":"_blank"}},[_vm._v("Creative Tim")]),_vm._v(".\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xp4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("2015 Sales")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products including Taxes")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Tesla Model S\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" BMW 5 Series\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.usersChart.data,"chart-options":_vm.usersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Users Behavior")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("24 hours performance")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n          "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Click\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Click Second Time\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.subscriptionsChart.data,"chart-options":_vm.subscriptionsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("169")]),_vm._v(" "),_c('span',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        -14%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total subscriptions "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 7 days\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View all members\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-angle-right"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.downloadsChart.data,"chart-options":_vm.downloadsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("8,960")]),_vm._v(" "),_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        ~51%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total downloads "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 6 years\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View more details\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-info"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('task-list'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('time-line',{attrs:{"type":"simple"}},[_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"danger","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-danger",attrs:{"slot":"header"},slot:"header"},[_vm._v("Some title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n          Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!!   It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"ti-time"}),_vm._v("\n          11 hours ago via Twitter\n        ")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"success","badgeIcon":"ti-credit-card"}},[_c('span',{staticClass:"label label-info",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n          Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"info","badgeIcon":"ti-check-box"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n            Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM")]),_vm._v(" "),_c('p',[_vm._v("\n            What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('drop-down',[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"slot":"title","type":"button","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#here"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#link"}},[_vm._v("Separated link")])])])],1)])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-chat"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Chat")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("With Tania Andrew")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ol',{staticClass:"chat"},[_c('li',{staticClass:"other"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg","alt":"crash"}})]),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Hola!\n                How are you?\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:20")])])])]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Puff...\n                I'm alright. How are you?\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:22")])])]),_vm._v(" "),_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})])]),_vm._v(" "),_c('li',{staticClass:"other"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg","alt":"crash"}})]),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                I'm ok too!\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:24")])])])]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Well, it was nice hearing from you.\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:25")])])]),_vm._v(" "),_c('div',{staticClass:"no-avatar"})]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                OK, bye-bye\n                See you!\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:25")])])]),_vm._v(" "),_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"send-message"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})]),_vm._v(" "),_c('input',{staticClass:"form-control textarea",attrs:{"type":"text","placeholder":"Type here!"}}),_vm._v(" "),_c('div',{staticClass:"send-button"},[_c('button',{staticClass:"btn btn-primary btn-fill"},[_vm._v("Send")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yKB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"list-unstyled team-members"},[_c('li',_vm._l((_vm.members),function(member){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":member.image,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_vm._v("\n            "+_vm._s(member.name)+"\n            "),_c('br'),_vm._v(" "),_c('span',{class:_vm.getStatusClass(member.status)},[_c('small',[_vm._v(_vm._s(member.status))])])]),_vm._v(" "),_vm._m(0,true)])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3 text-right"},[_c('button',{staticClass:"btn btn-sm btn-success btn-icon"},[_c('i',{staticClass:"fa fa-envelope"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yNZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"tag":"li","title":"5 Notificaitons","icon":"ti-bell"}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"slot":"title","href":"javascript:void(0)","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5")]),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Notifications\n        "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 3")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 4")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another notification")])])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"dropdown-toggle btn-magnify",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown"}},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "),_c('p',[_vm._v("Stats")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"btn-rotate",attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Settings\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yg6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularTables_vue__ = __webpack_require__("KyZi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3287d0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularTables_vue__ = __webpack_require__("Ws9Q");
function injectStyle (ssrContext) {
  __webpack_require__("IsOm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3287d0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yqcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z48K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card card-map"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Full Screen Map")])]),_vm._v(" "),_c('div',{staticClass:"full-screen-map",attrs:{"id":"map"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    }
  }
});

/***/ }),

/***/ "zmm5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.736acebb2fb5f18c0c6a.js